import { all, put, fork, takeEvery, select, delay, takeLatest } from 'redux-saga/effects';
import actions from './actions';
import authActions from '../auth/actions';
import trxActions from '../transactions/actions';
import { get, post, PUT, DELETE, postTest } from '@iso/lib/helpers/resApiRequestor';
import { filterDuplicateData, sortModuleByPosition } from '@iso/lib/helpers/utility';

export function* fetchAllRoles() {
  yield takeEvery('FETCH_ROLE_DATA', function* () {
    try {
      yield put({
        type: actions.FETCHING_ROLE_DATA,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield fetchAllRoleAPI(roleHeaderAuth);

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.FETCH_ROLE_DATA_SUCCESS,
          loading: false,
          result: result ? result.data : null
        });
      } else {
        yield put({
          type: actions.FETCH_ROLE_DATA_FAILED,
          loading: false
        });
      }
    } catch (error) {
      yield put({
        type: actions.FETCH_ROLE_DATA_FAILED,
        loading: false
      });
    }
  });
}
export function* fetchAllOTPServices() {
  yield takeEvery('FETCH_OTP_SERVICE_DATA', function* () {
    try {
      yield put({
        type: actions.FETCHING_OTP_SERVICE_DATA,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield fetchAllServiceDataAPI(roleHeaderAuth);

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.FETCH_OTP_SERVICE_DATA_SUCCESS,
          loading: false,
          result: result ? result.data : null
        });
        yield put({
          type: actions.SET_ACTIVE_OTP_SERVICE,
          otpService: result?.data?.length > 0 ? result.data[0] : null
        });
        yield put({
          type: actions.SET_IS_RESET_OTP_SERVICE_ACTIVE_DATA,
          payload: true
        });
      } else {
        yield put({
          type: actions.FETCH_OTP_SERVICE_DATA_FAILED,
          loading: false
        });
      }
    } catch (error) {
      yield put({
        type: actions.FETCH_OTP_SERVICE_DATA_FAILED,
        loading: false
      });
    }
  });
}
export function* fetchAllOTPServicesTemplate() {
  yield takeLatest('FETCH_OTP_SERVICE_TEMPLATE_DATA', function* ({ payload }) {
    try {
      yield put({
        type: actions.FETCHING_OTP_SERVICE_TEMPLATE_DATA,
        loading: true
      });

      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield fetchAllOTPServiceTemplateDataAPI(payload, roleHeaderAuth);

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.FETCH_OTP_SERVICE_TEMPLATE_DATA_SUCCESS,
          loading: false,
          result: result ? result.data : null
        });
      } else {
        yield put({
          type: actions.FETCH_OTP_SERVICE_TEMPLATE_DATA_FAILED,
          loading: false
        });
      }
    } catch (error) {
      yield put({
        type: actions.FETCH_OTP_SERVICE_TEMPLATE_DATA_FAILED,
        loading: false
      });
    }
  });
}
export function* fetchAllOTPIntegrators() {
  yield takeEvery('FETCH_OTP_INTEGRATORS', function* () {
    try {
      yield put({
        type: actions.FETCHING_OTP_INTEGRATORS,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield fetchAllOTPIntegratorsAPI(roleHeaderAuth);

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.FETCH_OTP_INTEGRATORS_SUCCESS,
          loading: false,
          result: result ? result.data : null
        });
      } else {
        yield put({
          type: actions.FETCH_OTP_INTEGRATORS_FAILED,
          loading: false
        });
      }
    } catch (error) {
      yield put({
        type: actions.FETCH_OTP_INTEGRATORS_FAILED,
        loading: false
      });
    }
  });
}
export function* fetchAllOTPLogs() {
  yield takeEvery('FETCH_OTP_LOGS', function* ({ payload }) {
    try {
      yield put({
        type: actions.FETCHING_OTP_LOGS,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield fetchAllOTPLogsAPI(payload, roleHeaderAuth);

      const result = apiResult.data;

      const logs = result?.data;
      const newLogs = logs?.map(log => {
        const requestBody =
          typeof log.request_body === 'string'
            ? log.request_body
            : JSON.stringify(log.request_body);
        return { ...log, request_body: requestBody };
      });
      if (result.success) {
        yield put({
          type: actions.FETCH_OTP_LOGS_SUCCESS,
          loading: false,
          result: result && newLogs ? newLogs : [],
          pagination: result && result.pagination ? result.pagination : {},
          filter: payload ? payload : {}
        });
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.FETCH_OTP_LOGS_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.FETCH_OTP_LOGS_FAILED,
            message: 'Failed to process request',
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.FETCH_OTP_LOGS_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* fetchAllOTPLogsActionCount() {
  yield takeLatest('FETCH_OTP_LOGS_ACTION_COUNT', function* ({ payload }) {
    try {
      yield put({
        type: actions.FETCHING_OTP_LOGS_ACTION_COUNT,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield fetchAllOTPLogsActionCountAPI(payload, roleHeaderAuth);

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.FETCH_OTP_LOGS_ACTION_COUNT_SUCCESS,
          loading: false,
          result: result?.data ?? [],
          filter: payload ? payload : {}
        });
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.FETCH_OTP_LOGS_ACTION_COUNT_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.FETCH_OTP_LOGS_ACTION_COUNT_FAILED,
            message: 'Failed to process request',
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.FETCH_OTP_LOGS_ACTION_COUNT_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* fetchAllIndustries() {
  yield takeEvery('FETCH_INDUSTRY_DATA', function* () {
    try {
      yield put({
        type: actions.FETCHING_INDUSTRY_DATA,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield fetchAllIndustryAPI(roleHeaderAuth);

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.FETCH_INDUSTRY_DATA_SUCCESS,
          loading: false,
          result: result ? result.data : null
        });
      } else {
        yield put({
          type: actions.FETCH_INDUSTRY_DATA_FAILED,
          loading: false
        });
      }
    } catch (error) {
      yield put({
        type: actions.FETCH_INDUSTRY_DATA_FAILED,
        loading: false
      });
    }
  });
}
export function* fetchAllAddresses() {
  yield takeEvery('FETCH_ADDRESSES_DATA', function* () {
    try {
      yield put({
        type: actions.FETCHING_ADDRESSES_DATA,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield fetchAllAddressAPI(roleHeaderAuth);

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.FETCH_ADDRESSES_DATA_SUCCESS,
          loading: false,
          result: result ? result.data : null
        });
      } else {
        yield put({
          type: actions.FETCH_ADDRESSES_DATA_FAILED,
          loading: false
        });
      }
    } catch (error) {
      yield put({
        type: actions.FETCH_ADDRESSES_DATA_FAILED,
        loading: false
      });
    }
  });
}

export function* fetchUserActivity() {
  yield takeEvery('FETCH_USER_SYSTEM_LOGS', function* ({ payload }) {
    try {
      yield put({
        type: actions.FETCHING_USER_SYSTEM_LOGS,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield fetchUserActivityAPI(
        payload,
        roleHeaderAuth
      );

      const result = apiResult.data;

      const logs = result?.data;
      const newLogs = logs?.map(log => {
        const value = typeof log.value === 'string' ? log.value : JSON.stringify(log.value);
        return { ...log, value };
      });

      if (result.success) {
        yield put({
          type: actions.FETCH_USER_SYSTEM_LOGS_SUCCESS,
          loading: false,
          result: result && newLogs ? newLogs : [],
          pagination: result.pagination ? result.pagination : null,
          filter: payload
        });
      } else {
        yield put({
          type: actions.FETCH_USER_SYSTEM_LOGS_FAILED,
          loading: false
        });
      }
    } catch (error) {
      yield put({
        type: actions.FETCH_USER_SYSTEM_LOGS_FAILED,
        loading: false
      });
    }
  });
}

export function* fetchRoleByID() {
  yield takeEvery('FETCH_ROLE_DATA_BY_ID', function* ({ payload }) {
    try {
      yield put({
        type: actions.FETCHING_ROLE_DATA_BY_ID,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield fetchRoleByIDAPI(payload, roleHeaderAuth);

      const result = apiResult.data;

      if (result.success) {
        const orderedModule = sortModuleByPosition(
          result && result.data && result.data.modules ? result.data.modules : []
        );
        yield put({
          type: actions.FETCH_ROLE_DATA_BY_ID_SUCCESS,
          loading: false,
          message: result.message,
          result: result
            ? {
                ...result.data,
                modules: orderedModule
              }
            : null
        });
      } else {
        yield put({
          type: actions.FETCH_ROLE_DATA_BY_ID_FAILED,
          message: result.message,
          loading: false
        });
      }
    } catch (error) {
      yield put({
        type: actions.FETCH_ROLE_DATA_BY_ID_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}
export function* addRoleData() {
  yield takeEvery('ADD_ROLE_DATA', function* ({ payload }) {
    try {
      yield put({
        type: actions.ADDING_ROLE_DATA,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield addRoleDataAPI(payload, roleHeaderAuth);

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.ADD_ROLE_DATA_SUCCESS,
          loading: false,
          message: result.message
        });
        yield put({
          type: actions.FETCH_ROLE_DATA
        });
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.ADD_ROLE_DATA_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.ADD_ROLE_DATA_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.ADD_ROLE_DATA_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}
export function* editRoleData() {
  yield takeEvery('EDIT_ROLE_DATA', function* ({ payload, id, modules }) {
    try {
      const state = yield select();
      const identity = state.Auth.identity;
      yield put({
        type: actions.EDITING_ROLE_DATA,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield editRoleDataAPI(payload, id, roleHeaderAuth);

      const result = apiResult.data;
      if (result.success) {
        yield put({
          type: actions.EDIT_ROLE_DATA_SUCCESS,
          loading: false,
          message: result.message
        });
        yield put({
          type: actions.FETCH_ROLE_DATA
        });
        yield put({
          type: actions.FETCH_ROLE_DATA_BY_ID,
          payload: id
        });
        if (identity.role_id === id) {
          yield put({
            type: authActions.UPDATE_ACTIVE_ROLE_MODULES,
            payload: modules
          });
        }
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.EDIT_ROLE_DATA_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.EDIT_ROLE_DATA_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.EDIT_ROLE_DATA_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}
export function* addUserData() {
  yield takeEvery('ADD_USER_DATA', function* ({ payload }) {
    try {
      yield put({
        type: actions.ADDING_USER_DATA,
        loading: true
      });
      const state = yield select();
      const userPagination = state.Tools.userPagination;
      const userData = state.Tools.userData;
      const userFilter = state.Tools.userFilter;
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield addUserDataAPI(payload, roleHeaderAuth);

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.ADD_USER_DATA_SUCCESS,
          loading: false,
          message: result.message,
          result: result ? result.data : null
        });
        yield put({
          type: actions.FETCH_USER_DATA,
          payload: {
            ...userFilter,
            pagination: {
              page: userPagination.current_page,
              limit: userPagination.page_size,
              loadMore: userPagination.current_page >= 1,
              currentUserList: userData
            }
          }
        });
      } else {
        yield put({
          type: actions.ADD_USER_DATA_FAILED,
          message: result.message,
          loading: false
        });
      }
    } catch (error) {
      yield put({
        type: actions.ADD_USER_DATA_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* fetchAllUserDeptData() {
  yield takeEvery('FETCH_ALL_USER_DEPT_DATA', function* () {
    try {
      yield put({
        type: actions.FETCHING_ALL_USER_DEPT_DATA,
        loading: true
      });

      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield fetchAllUserDeptDataAPI(roleHeaderAuth);
      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.FETCH_ALL_USER_DEPT_DATA_SUCCESS,
          loading: false,
          result: result.data
        });
      } else {
        yield put({
          type: actions.FETCH_ALL_USER_DEPT_DATA_FAILED,
          loading: false
        });
      }
    } catch (e) {
      yield put({
        type: actions.FETCH_ALL_USER_DEPT_DATA_FAILED,
        loading: false
      });
    }
  });
}

export function* fetchAllUsers() {
  yield takeEvery('FETCH_USER_DATA', function* ({ payload }) {
    try {
      const pagination = payload.pagination;
      const loadmore = pagination.loadMore;
      if (loadmore) {
        yield put({
          type: actions.LOADING_MORE_USER_DATA
        });
      } else {
        yield put({
          type: actions.FETCHING_USER_DATA,
          loading: true
        });
      }
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield fetchAllUserAPI(payload, roleHeaderAuth);
      const currentList = pagination.currentUserList && loadmore ? pagination.currentUserList : [];

      const result = apiResult.data;

      const parseData =
        currentList && currentList.length > 0 ? currentList.concat(result.data) : result.data;

      const finalData = filterDuplicateData(parseData);

      if (result.success) {
        yield put({
          type: actions.FETCH_USER_DATA_SUCCESS,
          loading: false,
          result: finalData,
          pagination: result ? result.pagination : null,
          filter: payload
        });
      } else {
        yield put({
          type: actions.FETCH_USER_DATA_FAILED,
          loading: false
        });
      }
    } catch (error) {
      yield put({
        type: actions.FETCH_USER_DATA_FAILED,
        loading: false
      });
    }
  });
}
export function* fetchAllLookups() {
  yield takeEvery('FETCH_LOOKUPS_DATA', function* () {
    try {
      yield put({
        type: actions.FETCHING_LOOKUPS_DATA,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield fetchAllLookupsAPI(roleHeaderAuth);

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.FETCH_LOOKUPS_DATA_SUCCESS,
          loading: false,
          result: result ? result.data : null
        });
      } else {
        yield put({
          type: actions.FETCH_LOOKUPS_DATA_FAILED,
          loading: false
        });
      }
    } catch (error) {
      yield put({
        type: actions.FETCH_LOOKUPS_DATA_FAILED,
        loading: false
      });
    }
  });
}

export function* fetchLookupsDataRevamped() {
  yield takeEvery('FETCH_LOOKUPS_DATA_REVAMPED', function* () {
    try {
      yield put({
        type: actions.FETCHING_LOOKUPS_DATA_REVAMPED,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield fetchLookupsDataRevampedAPI(roleHeaderAuth);

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.FETCH_LOOKUPS_DATA_REVAMPED_SUCCESS,
          loading: false,
          result: result ? result.data : null
        });
      } else {
        yield put({
          type: actions.FETCH_LOOKUPS_DATA_REVAMPED_FAILED,
          loading: false
        });
      }
    } catch (error) {
      yield put({
        type: actions.FETCH_LOOKUPS_DATA_REVAMPED_FAILED,
        loading: false
      });
    }
  });
}

export function* addLookupsData() {
  yield takeEvery('ADD_LOOKUPS_DATA', function* ({ payload }) {
    try {
      yield put({
        type: actions.ADDING_LOOKUPS_DATA,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield addLookupsDataAPI(payload, roleHeaderAuth);

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.ADD_LOOKUPS_DATA_SUCCESS,
          loading: false,
          message: result.message
        });
        yield put({
          type: actions.FETCH_LOOKUPS_DATA_REVAMPED
        });
        yield put({
          type: actions.EDITED_LOOKUPS_DATA,
          edited: true
        });
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.ADD_LOOKUPS_DATA_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.ADD_LOOKUPS_DATA_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.ADD_LOOKUPS_DATA_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}
export function* editLookupsData() {
  yield takeEvery('EDIT_LOOKUPS_DATA', function* ({ payload, id }) {
    try {
      yield put({
        type: actions.EDITING_LOOKUPS_DATA,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield editLookupsDataAPI(payload, id, roleHeaderAuth);

      const result = apiResult.data;
      if (result.success) {
        yield put({
          type: actions.EDIT_LOOKUPS_DATA_SUCCESS,
          loading: false,
          message: result.message
        });
        yield put({
          type: actions.FETCH_LOOKUPS_DATA_REVAMPED
        });
        yield put({
          type: actions.EDITED_LOOKUPS_DATA,
          edited: true
        });
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.EDIT_LOOKUPS_DATA_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.EDIT_LOOKUPS_DATA_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.EDIT_LOOKUPS_DATA_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}
export function* editSystemStatus() {
  yield takeEvery('EDIT_SYSTEM_MODULE_STATUS', function* ({ payload, id }) {
    try {
      yield put({
        type: actions.EDITING_SYSTEM_MODULE_STATUS,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield editSystemStatusAPI(payload, id, roleHeaderAuth);

      const result = apiResult.data;
      if (result.success) {
        yield put({
          type: actions.EDIT_SYSTEM_MODULE_STATUS_SUCCESS,
          loading: false,
          message: result.message
        });
        yield put({
          type: actions.FETCH_MODULE_DATA
        });
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.EDIT_SYSTEM_MODULE_STATUS_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.EDIT_SYSTEM_MODULE_STATUS_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.EDIT_SYSTEM_MODULE_STATUS_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}
export function* editLookupGroupData() {
  yield takeEvery('EDIT_LOOKUP_GROUP_DATA', function* ({ payload, id }) {
    try {
      yield put({
        type: actions.EDITING_LOOKUP_GROUP_DATA,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield editLookupGroupDataAPI(payload, id, roleHeaderAuth);

      const result = apiResult.data;
      if (result.success) {
        yield put({
          type: actions.EDIT_LOOKUP_GROUP_DATA_SUCCESS,
          loading: false,
          message: result.message
        });
        yield put({
          type: actions.FETCH_LOOKUPS_DATA_REVAMPED
        });
        yield put({
          type: actions.EDITED_LOOKUPS_DATA,
          edited: true
        });
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.EDIT_LOOKUP_GROUP_DATA_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.EDIT_LOOKUP_GROUP_DATA_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.EDIT_LOOKUP_GROUP_DATA_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}
export function* addIndustryData() {
  yield takeEvery('ADD_INDUSTRY_DATA', function* ({ payload }) {
    try {
      yield put({
        type: actions.ADDING_INDUSTRY_DATA,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield addIndustryDataAPI(payload, roleHeaderAuth);

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.ADD_INDUSTRY_DATA_SUCCESS,
          loading: false,
          message: result.message
        });
        yield put({
          type: actions.FETCH_INDUSTRY_DATA
        });
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.ADD_INDUSTRY_DATA_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.ADD_INDUSTRY_DATA_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.ADD_INDUSTRY_DATA_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}
export function* editIndustryData() {
  yield takeEvery('EDIT_INDUSTRY_DATA', function* ({ payload, id }) {
    try {
      yield put({
        type: actions.EDITING_INDUSTRY_DATA,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield editIndustryDataAPI(payload, id, roleHeaderAuth);

      const result = apiResult.data;
      if (result.success) {
        yield put({
          type: actions.EDIT_INDUSTRY_DATA_SUCCESS,
          loading: false,
          message: result.message
        });
        yield put({
          type: actions.FETCH_INDUSTRY_DATA
        });
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.EDIT_INDUSTRY_DATA_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.EDIT_INDUSTRY_DATA_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.EDIT_INDUSTRY_DATA_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}
export function* addPaymentChannelData() {
  yield takeEvery('ADD_PAYMENT_CHANNEL_DATA', function* ({ payload }) {
    try {
      yield put({
        type: actions.ADDING_PAYMENT_CHANNEL_DATA,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield addPaymentChannelAPI(payload, roleHeaderAuth);

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.ADD_PAYMENT_CHANNEL_DATA_SUCCESS,
          loading: false,
          message: result.message
        });
        yield put({
          type: actions.FETCH_INDUSTRY_DATA
        });
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.ADD_PAYMENT_CHANNEL_DATA_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.ADD_PAYMENT_CHANNEL_DATA_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.ADD_PAYMENT_CHANNEL_DATA_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}
export function* addAddressData() {
  yield takeEvery('ADD_ADDRESS_DATA', function* ({ payload }) {
    try {
      yield put({
        type: actions.ADDING_ADDRESS_DATA,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield addAddressDataAPI(payload, roleHeaderAuth);

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.ADD_ADDRESS_DATA_SUCCESS,
          loading: false,
          message: result.message
        });
        yield put({
          type: actions.FETCH_ADDRESSES_DATA
        });
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.ADD_ADDRESS_DATA_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.ADD_ADDRESS_DATA_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.ADD_ADDRESS_DATA_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}
export function* addOTPServiceData() {
  yield takeEvery('ADD_OTP_SERVICE_DATA', function* ({ payload }) {
    try {
      yield put({
        type: actions.ADDING_OTP_SERVICE_DATA,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield addOtpAddressAPI(payload, roleHeaderAuth);

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.ADD_OTP_SERVICE_DATA_SUCCESS,
          loading: false,
          message: result.message
        });
        yield put({
          type: actions.FETCH_OTP_SERVICE_DATA
        });
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.ADD_OTP_SERVICE_DATA_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.ADD_OTP_SERVICE_DATA_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.ADD_OTP_SERVICE_DATA_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}
export function* addOTPServiceTemplateData() {
  yield takeEvery('ADD_OTP_SERVICE_TEMPLATE_DATA', function* ({ payload }) {
    try {
      yield put({
        type: actions.ADDING_OTP_SERVICE_TEMPLATE_DATA,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield addOTPTemplateAPI(payload, roleHeaderAuth);

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.ADD_OTP_SERVICE_TEMPLATE_DATA_SUCCESS,
          loading: false,
          message: result.message
        });
        if (payload.application_id && payload.application_id.length > 0) {
          yield put({
            type: actions.FETCH_OTP_SERVICE_TEMPLATE_DATA,
            payload: payload.application_id
          });
        }
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.ADD_OTP_SERVICE_TEMPLATE_DATA_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.ADD_OTP_SERVICE_TEMPLATE_DATA_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.ADD_OTP_SERVICE_TEMPLATE_DATA_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* testGenerateOTP() {
  yield takeEvery('TEST_GENERATE_OTP', function* ({ payload, header }) {
    try {
      yield put({
        type: actions.TESTING_GENERATE_OTP,
        loading: true
      });
      const apiResult = yield testGenerateOTPAPI(payload, header);

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.TEST_GENERATE_OTP_SUCCESS,
          loading: false,
          message: result.message,
          result: result
        });
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.TEST_GENERATE_OTP_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false,
            result
          });
        } else {
          yield put({
            type: actions.TEST_GENERATE_OTP_FAILED,
            message: result.message,
            loading: false,
            result
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.TEST_GENERATE_OTP_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* addProvinceData() {
  yield takeEvery('ADD_PROVINCE_DATA', function* ({ payload }) {
    try {
      yield put({
        type: actions.ADDING_PROVINCE_DATA,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield addProvinceDataAPI(payload, roleHeaderAuth);

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.ADD_PROVINCE_DATA_SUCCESS,
          loading: false,
          message: result.message
        });
        yield put({
          type: actions.FETCH_ADDRESSES_DATA
        });
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.ADD_PROVINCE_DATA_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.ADD_PROVINCE_DATA_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.ADD_PROVINCE_DATA_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}
export function* defineKeyCities() {
  yield takeEvery('DEFINE_KEY_CITIES', function* ({ payload }) {
    try {
      yield put({
        type: actions.DEFINING_KEY_CITIES,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield defineKeyCitiesAPI(payload, roleHeaderAuth);

      const result = apiResult.data;
      if (result.success) {
        yield put({
          type: actions.DEFINE_KEY_CITIES_SUCCESS,
          loading: false,
          message: result.message
        });
        yield put({
          type: actions.FETCH_ADDRESSES_DATA
        });
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.DEFINE_KEY_CITIES_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.DEFINE_KEY_CITIES_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.DEFINE_KEY_CITIES_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}
export function* deleteLookupData() {
  yield takeEvery('DELETE_LOOKUP_DATA', function* ({ payload }) {
    try {
      yield put({
        type: actions.DELETING_LOOKUP_DATA,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield deleteLookupDataAPI(payload, roleHeaderAuth);

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.DELETE_LOOKUP_DATA_SUCCESS,
          loading: false,
          message: result.message
        });
        yield put({
          type: actions.FETCH_LOOKUPS_DATA
        });
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.DELETE_LOOKUP_DATA_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.DELETE_LOOKUP_DATA_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.DELETE_LOOKUP_DATA_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}
export function* editAddressData() {
  yield takeEvery('EDIT_ADDRESS_DATA', function* ({ payload, id }) {
    try {
      yield put({
        type: actions.EDITING_ADDRESS_DATA,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield editAddressDataAPI(payload, id, roleHeaderAuth);

      const result = apiResult.data;
      if (result.success) {
        yield put({
          type: actions.EDIT_ADDRESS_DATA_SUCCESS,
          loading: false,
          message: result.message
        });
        yield put({
          type: actions.FETCH_ADDRESSES_DATA
        });
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.EDIT_ADDRESS_DATA_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.EDIT_ADDRESS_DATA_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.EDIT_ADDRESS_DATA_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}
export function* editOtpConfig() {
  yield takeEvery('EDIT_OTP_SETTINGS_DATA', function* ({ payload, id }) {
    try {
      yield put({
        type: actions.EDITING_OTP_SETTINGS_DATA,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield editOTPSettingsDataAPI(payload, id, roleHeaderAuth);

      const result = apiResult.data;
      if (result.success) {
        yield put({
          type: actions.EDIT_OTP_SETTINGS_DATA_SUCCESS,
          loading: false,
          message: result.message
        });
        yield put({
          type: actions.FETCH_OTP_SERVICE_DATA
        });
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.EDIT_OTP_SETTINGS_DATA_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.EDIT_OTP_SETTINGS_DATA_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.EDIT_OTP_SETTINGS_DATA_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}
export function* editOTPConfigTemplate() {
  yield takeEvery('EDIT_OTP_SETTINGS_TEMPLATE_DATA', function* ({ payload, id }) {
    try {
      yield put({
        type: actions.EDITING_OTP_SETTINGS_TEMPLATE_DATA,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield editOTPSettingsTemplateDataAPI(payload, id, roleHeaderAuth);

      const result = apiResult.data;
      if (result.success) {
        yield put({
          type: actions.EDIT_OTP_SETTINGS_TEMPLATE_DATA_SUCCESS,
          loading: false,
          message: result.message
        });
        if (payload && payload.application_id && payload.application_id.length > 0) {
          yield put({
            type: actions.FETCH_OTP_SERVICE_TEMPLATE_DATA,
            payload: payload.application_id
          });
        }
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.EDIT_OTP_SETTINGS_TEMPLATE_DATA_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.EDIT_OTP_SETTINGS_TEMPLATE_DATA_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.EDIT_OTP_SETTINGS_TEMPLATE_DATA_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}
export function* generateNewOTPKey() {
  yield takeEvery('GENERATE_NEW_OTP_KEY_DATA', function* ({ payload, id }) {
    try {
      yield put({
        type: actions.GENERATING_NEW_OTP_KEY_DATA,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield generateNewKeyAPI(payload, id, roleHeaderAuth);

      const result = apiResult.data;
      if (result.success) {
        yield put({
          type: actions.GENERATE_NEW_OTP_KEY_DATA_SUCCESS,
          loading: false,
          message: result.message
        });
        yield put({
          type: actions.FETCH_OTP_SERVICE_DATA
        });
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.GENERATE_NEW_OTP_KEY_DATA_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.GENERATE_NEW_OTP_KEY_DATA_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.GENERATE_NEW_OTP_KEY_DATA_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}
export function* changeAddressStatusData() {
  yield takeEvery('CHANGE_STATUS_ADDRESS_DATA', function* ({ payload, id }) {
    try {
      yield put({
        type: actions.CHANGING_STATUS_ADDRESS_DATA,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield changeStatusAddressDataAPI(payload, id, roleHeaderAuth);

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.CHANGE_STATUS_ADDRESS_DATA_SUCCESS,
          loading: false,
          message: result.message
        });
        yield put({
          type: actions.FETCH_ADDRESSES_DATA
        });
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.CHANGE_STATUS_ADDRESS_DATA_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.CHANGE_STATUS_ADDRESS_DATA_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.CHANGE_STATUS_ADDRESS_DATA_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}
export function* changeIndustryStatusData() {
  yield takeEvery('CHANGE_STATUS_INDUSTRY_DATA', function* ({ payload, id }) {
    try {
      yield put({
        type: actions.CHANGING_STATUS_INDUSTRY_DATA,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield changeIndustryStatusDataAPI(payload, id, roleHeaderAuth);

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.CHANGE_STATUS_INDUSTRY_DATA_SUCCESS,
          loading: false,
          message: result.message
        });
        yield put({
          type: actions.FETCH_INDUSTRY_DATA
        });
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.CHANGE_STATUS_INDUSTRY_DATA_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.CHANGE_STATUS_INDUSTRY_DATA_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.CHANGE_STATUS_INDUSTRY_DATA_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}
export function* deleteRoleData() {
  yield takeEvery('DELETE_ROLE_DATA', function* ({ payload }) {
    try {
      yield put({
        type: actions.DELETING_ROLE_DATA,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield deleteRoleDataAPI(payload, roleHeaderAuth);

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.DELETE_ROLE_DATA_SUCCESS,
          loading: false,
          message: result.message
        });
        yield put({
          type: actions.FETCH_ROLE_DATA
        });
        yield put({
          type: actions.FETCH_ROLE_DATA_BY_ID,
          payload
        });
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.DELETE_ROLE_DATA_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.DELETE_ROLE_DATA_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.DELETE_ROLE_DATA_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}
export function* deleteUserData() {
  yield takeEvery('DELETE_USER_DATA', function* ({ payload }) {
    try {
      yield put({
        type: actions.DELETING_USER_DATA,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const state = yield select();
      const userPagination = state.Tools.userPagination;
      const userData = state.Tools.userData;
      const userFilter = state.Tools.userFilter;
      const apiResult = yield deleteUserDataAPI(payload, roleHeaderAuth);

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.DELETE_USER_DATA_SUCCESS,
          loading: false,
          message: result.message
        });
        yield put({
          type: actions.FETCH_USER_DATA,
          payload: {
            ...userFilter,
            pagination: {
              page: userPagination.current_page,
              limit: userPagination.page_size,
              loadMore: userPagination.current_page >= 1,
              currentUserList: userData
            }
          }
        });
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.DELETE_USER_DATA_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.DELETE_USER_DATA_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.DELETE_USER_DATA_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}
export function* editUserData() {
  yield takeEvery('EDIT_USER_DATA', function* ({ payload, id }) {
    try {
      yield put({
        type: actions.EDITING_USER_DATA,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      // const state = yield select();
      // const userPagination = state.Tools.userPagination;
      // const userData = state.Tools.userData;
      // const userFilter = state.Tools.userFilter;
      const apiResult = yield editUserDataAPI(payload, id, roleHeaderAuth);

      const result = apiResult.data;
      if (result.success) {
        yield put({
          type: actions.EDIT_USER_DATA_SUCCESS,
          loading: false,
          message: result.message
        });
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.EDIT_USER_DATA_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.EDIT_USER_DATA_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.EDIT_USER_DATA_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}
export function* resetUserPassword() {
  yield takeEvery('RESET_USER_PASSWORD', function* ({ payload, id }) {
    try {
      yield put({
        type: actions.RESETTING_USER_PASSWORD,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield resetUserPasswordAPI(payload, id, roleHeaderAuth);

      const result = apiResult.data;
      if (result.success) {
        yield put({
          type: actions.RESET_USER_PASSWORD_SUCCESS,
          loading: false,
          message: result.message
        });
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.RESET_USER_PASSWORD_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.RESET_USER_PASSWORD_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.RESET_USER_PASSWORD_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* unlockUser() {
  yield takeEvery('UNLOCK_USER_ACCOUNT', function* ({ payload, id }) {
    try {
      yield put({
        type: actions.UNLOCKING_USER,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const state = yield select();
      const userPagination = state.Tools.userPagination;
      //const userData = state.Tools.userData;
      const userFilter = state.Tools.userFilter;
      const apiResult = yield unlockUserAPI(payload, id, roleHeaderAuth);

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.UNLOCK_USER_SUCCESS,
          loading: false,
          message: result.message
        });
        yield put({
          type: actions.FETCH_USER_DATA,
          payload: {
            ...userFilter,
            pagination: {
              page: userPagination.current_page,
              limit: userPagination.page_size,
              //loadMore: false,
              //currentUserList: userData
            }
          }
        });
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.UNLOCK_USER_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.UNLOCK_USER_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.UNLOCK_USER_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}
export function* changeUserStatus() {
  yield takeEvery('CHANGE_USER_STATUS', function* ({ payload, id }) {
    try {
      yield put({
        type: actions.CHANGING_USER_STATUS,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const state = yield select();
      const userPagination = state.Tools.userPagination;
      //const userData = state.Tools.userData;
      const userFilter = state.Tools.userFilter;
      const apiResult = yield changeStatusUserDataAPI(payload, id, roleHeaderAuth);

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.CHANGE_USER_STATUS_SUCCESS,
          loading: false,
          message: result.message
        });
        yield put({
          type: actions.FETCH_USER_DATA,
          payload: {
            ...userFilter,
            pagination: {
              page: userPagination.current_page,
              limit: userPagination.page_size,
              //loadMore: false,
              //currentUserList: userData
            }
          }
        });
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.CHANGE_USER_STATUS_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.CHANGE_USER_STATUS_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.CHANGE_USER_STATUS_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* fetchAllModules() {
  yield takeEvery('FETCH_MODULE_DATA', function* () {
    try {
      yield put({
        type: actions.FETCHING_MODULE_DATA,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield fetchAllModuleAPI(roleHeaderAuth);

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.FETCH_MODULE_DATA_SUCCESS,
          loading: false,
          result: result ? result.data : null
        });
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.FETCH_MODULE_DATA_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.FETCH_MODULE_DATA_FAILED,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.FETCH_MODULE_DATA_FAILED,
        loading: false
      });
    }
  });
}

export function* addModuleData() {
  yield takeEvery('ADD_MODULE_DATA', function* ({ payload }) {
    try {
      yield put({
        type: actions.ADDING_MODULE_DATA,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield addModuleDataAPI(payload, roleHeaderAuth);

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.ADD_MODULE_DATA_SUCCESS,
          loading: false,
          message: result.message
        });
        yield put({
          type: actions.FETCH_MODULE_DATA
        });
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.ADD_MODULE_DATA_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.ADD_MODULE_DATA_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.ADD_MODULE_DATA_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}
export function* fetchPaymentChannelsData() {
  yield takeEvery('FETCH_PCHANNEL_DATA', function* ({ payload }) {
    try {
      yield put({
        type: actions.FETCHING_PCHANNEL_DATA,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield fetchPChannelDataAPI(roleHeaderAuth);

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.FETCH_PCHANNEL_DATA_SUCCESS,
          loading: false,
          result: result ? result.data : []
        });
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.FETCH_PCHANNEL_DATA_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.FETCH_PCHANNEL_DATA_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.FETCH_PCHANNEL_DATA_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}
export function* fetchNotificationData() {
  yield takeEvery('FETCH_NOTIFICATION_DATA', function* ({ payload }) {
    try {
      yield put({
        type: actions.FETCHING_NOTIFICATION_DATA,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield fetchNotificationDataAPI(roleHeaderAuth);

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.FETCH_NOTIFICATION_DATA_SUCCESS,
          loading: false,
          result: result ? result.data : []
        });
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.FETCH_NOTIFICATION_DATA_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.FETCH_NOTIFICATION_DATA_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.FETCH_NOTIFICATION_DATA_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}
export function* addNotificationData() {
  yield takeEvery('ADD_NOTIFICATION_DATA', function* ({ payload }) {
    try {
      yield put({
        type: actions.ADDING_NOTIFICATION_DATA,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield addNotificationDataAPI(payload, roleHeaderAuth);

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.ADD_NOTIFICATION_DATA_SUCCESS,
          loading: false,
          message: result.message
        });
        yield put({
          type: actions.FETCH_NOTIFICATION_DATA
        });
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.ADD_NOTIFICATION_DATA_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.ADD_NOTIFICATION_DATA_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.ADD_NOTIFICATION_DATA_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}
export function* updateAppNotificationData() {
  yield takeEvery('UPDATE_APP_NOTIFICATION', function* ({ payload, id }) {
    try {
      yield put({
        type: actions.UPDATING_APP_NOTIFICATION,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield updateAppNotificationAPI(payload, id, roleHeaderAuth);

      const result = apiResult.data;
      if (result.success) {
        yield put({
          type: actions.UPDATE_APP_NOTIFICATION_SUCCESS,
          loading: false,
          message: result.message
        });

        yield put({
          type: actions.FETCH_NOTIFICATION_DATA
        });
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.UPDATE_APP_NOTIFICATION_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.UPDATE_APP_NOTIFICATION_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.UPDATE_APP_NOTIFICATION_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}
export function* fetchUsers() {
  yield takeEvery(actions.FETCH_USERS, function* ({ payload }) {
    try {
      yield put({
        type: actions.FETCHING_USERS,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield fetchUsersAPI(payload, roleHeaderAuth);

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.FETCH_USERS_SUCCESS,
          loading: false,
          result: result ? result.data : null
        });
      } else {
        yield put({
          type: actions.FETCH_USERS_FAILED,
          loading: false,
          result: []
        });
      }
    } catch (error) {
      yield put({
        type: actions.FETCH_USERS_FAILED,
        payload: [],
        loading: false
      });
    }
  });
}

export function* getUserListByRole() {
  yield takeEvery('GET_USER_LIST_BY_ROLE', function* ({ payload }) {
    try {
      yield put({
        type: actions.GETTING_USER_LIST_BY_ROLE,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield fetchUserListByRoleIDAPI(payload, roleHeaderAuth);

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.GET_USER_LIST_BY_ROLE_SUCCESS,
          loading: false,
          result: result ? result.data : null
        });
      } else {
        yield put({
          type: actions.GET_USER_LIST_BY_ROLE_FAILED,
          loading: false,
          result: []
        });
      }
    } catch (error) {
      yield put({
        type: actions.GET_USER_LIST_BY_ROLE_FAILED,
        payload: [],
        loading: false
      });
    }
  });
}

export function* reorderLookupData() {
  yield takeEvery('REORDER_LOOKUP_DATA', function* ({ payload }) {
    try {
      yield put({
        type: actions.REORDERING_LOOKUP_DATA,
        loading: true
      });

      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield reorderLookupDataAPI(payload, roleHeaderAuth);

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.REORDER_LOOKUP_DATA_SUCCESS,
          loading: false,
          message: result.message
        });
        yield put({
          type: actions.RESET_LOOKUPS_DATA
        });
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.REORDER_LOOKUP_DATA_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.REORDER_LOOKUP_DATA_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.REORDER_LOOKUP_DATA_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}
export function* reorderPageData() {
  yield takeEvery('REORDER_PAGE_DATA', function* ({ payload }) {
    try {
      yield put({
        type: actions.REORDERING_PAGE_DATA,
        loading: true
      });

      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield reorderPageDataAPI(payload, roleHeaderAuth);

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.REORDER_PAGE_DATA_SUCCESS,
          loading: false,
          message: result.message
        });
        yield put({
          type: actions.FETCH_MODULE_DATA
        });
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.REORDER_PAGE_DATA_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.REORDER_PAGE_DATA_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.REORDER_PAGE_DATA_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}
export function* reorderModuleData() {
  yield takeEvery('REORDER_MODULE_DATA', function* ({ payload }) {
    try {
      yield put({
        type: actions.REORDERING_MODULE_DATA,
        loading: true
      });

      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield reorderModuleDataAPI(payload, roleHeaderAuth);

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.REORDER_MODULE_DATA_SUCCESS,
          loading: false,
          message: result.message
        });
        yield put({
          type: actions.FETCH_MODULE_DATA
        });
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.REORDER_MODULE_DATA_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.REORDER_MODULE_DATA_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.REORDER_MODULE_DATA_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}
export function* fetchAllExternalRecipients() {
  yield takeEvery('FETCH_EXTERNAL_RECIPIENTS_DATA', function* () {
    try {
      yield put({
        type: actions.FETCHING_EXTERNAL_RECIPIENTS_DATA,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield fetchAllExternalRecipientsAPI(roleHeaderAuth);

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.FETCH_EXTERNAL_RECIPIENTS_DATA_SUCCESS,
          loading: false,
          result: result ? result.data : null
        });
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.FETCH_EXTERNAL_RECIPIENTS_DATA_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.FETCH_EXTERNAL_RECIPIENTS_DATA_FAILED,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.FETCH_EXTERNAL_RECIPIENTS_DATA_FAILED,
        loading: false
      });
    }
  });
}
export function* editExternalRecipientData() {
  yield takeEvery('EDIT_EXTERNAL_RECIPIENT_DATA', function* ({ payload, id }) {
    try {
      yield put({
        type: actions.EDITING_EXTERNAL_RECIPIENT_DATA,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield editExternalRecipientAPI(payload, id, roleHeaderAuth);

      const result = apiResult.data;
      if (result.success) {
        yield put({
          type: actions.EDIT_EXTERNAL_RECIPIENT_DATA_SUCCESS,
          loading: false,
          message: result.message
        });
        yield put({
          type: actions.FETCH_EXTERNAL_RECIPIENTS_DATA
        });
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.EDIT_EXTERNAL_RECIPIENT_DATA_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.EDIT_EXTERNAL_RECIPIENT_DATA_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.EDIT_EXTERNAL_RECIPIENT_DATA_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* fetchLookupValidation() {
  yield takeEvery('FETCH_LOOKUP_VALIDATION_DATA', function* ({ payload }) {
    try {
      yield put({
        type: actions.FETCHING_LOOKUP_VALIDATION_DATA,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield fetchAllLookupValidationAPI(roleHeaderAuth);

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.FETCH_LOOKUP_VALIDATION_DATA_SUCCESS,
          loading: false,
          result: result ? result.data : null
        });
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.FETCH_LOOKUP_VALIDATION_DATA_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.FETCH_LOOKUP_VALIDATION_DATA_FAILED,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.FETCH_LOOKUP_VALIDATION_DATA_FAILED,
        loading: false
      });
    }
  });
}
export function* setLookupValidationData() {
  yield takeEvery('SET_LOOKUP_VALIDATION_DATA', function* ({ payload, id }) {
    try {
      yield put({
        type: actions.SETTING_LOOKUP_VALIDATION_DATA,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield setLookupValidationDataAPI(payload, id, roleHeaderAuth);

      const result = apiResult.data;
      if (result.success) {
        yield put({
          type: actions.SET_LOOKUP_VALIDATION_DATA_SUCCESS,
          loading: false,
          message: result.message
        });
        yield put({
          type: actions.FETCH_LOOKUP_VALIDATION_DATA
        });
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.SET_LOOKUP_VALIDATION_DATA_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.SET_LOOKUP_VALIDATION_DATA_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.SET_LOOKUP_VALIDATION_DATA_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}
export function* editLookupValidationData() {
  yield takeEvery('EDIT_LOOKUP_VALIDATION_DATA', function* ({ payload, id }) {
    try {
      yield put({
        type: actions.EDITING_LOOKUP_VALIDATION_DATA,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield editLookupValidationDataAPI(payload, id, roleHeaderAuth);

      const result = apiResult.data;
      if (result.success) {
        yield put({
          type: actions.EDIT_LOOKUP_VALIDATION_DATA_SUCCESS,
          loading: false,
          message: result.message
        });
        yield put({
          type: actions.FETCH_LOOKUP_VALIDATION_DATA
        });
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.EDIT_LOOKUP_VALIDATION_DATA_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.EDIT_LOOKUP_VALIDATION_DATA_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.EDIT_LOOKUP_VALIDATION_DATA_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}
export function* deleteLookupValidationData() {
  yield takeEvery('DELETE_LOOKUP_VALIDATION_DATA', function* ({ payload }) {
    try {
      yield put({
        type: actions.DELETING_LOOKUP_VALIDATION_DATA,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield deleteLookupValidationDataAPI(payload, roleHeaderAuth);

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.DELETE_LOOKUP_VALIDATION_DATA_SUCCESS,
          loading: false,
          message: result.message
        });
        yield put({
          type: actions.FETCH_LOOKUP_VALIDATION_DATA
        });
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.DELETE_LOOKUP_VALIDATION_DATA_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.DELETE_LOOKUP_VALIDATION_DATA_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.DELETE_LOOKUP_VALIDATION_DATA_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}
export function* fetchPaymentChannelListData() {
  yield takeEvery('FETCH_PAYMENT_CHANNEL_LIST_DATA', function* ({ payload }) {
    try {
      yield put({
        type: actions.FETCHING_PAYMENT_CHANNEL_LIST_DATA,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield fetchPChannelListDataAPI(payload, roleHeaderAuth);

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.FETCH_PAYMENT_CHANNEL_LIST_DATA_SUCCESS,
          loading: false,
          result: result ? result.data : []
        });
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.FETCH_PAYMENT_CHANNEL_LIST_DATA_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.FETCH_PAYMENT_CHANNEL_LIST_DATA_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.FETCH_PAYMENT_CHANNEL_LIST_DATA_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}
export function* fetchPaymentMethodListData() {
  yield takeEvery('FETCH_PAYMENT_METHOD_LIST_DATA', function* ({ payload }) {
    try {
      yield put({
        type: actions.FETCHING_PAYMENT_METHOD_LIST_DATA,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield fetchPMethodListDataAPI(roleHeaderAuth);

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.FETCH_PAYMENT_METHOD_LIST_DATA_SUCCESS,
          loading: false,
          result: result ? result.data : []
        });
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.FETCH_PAYMENT_METHOD_LIST_DATA_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.FETCH_PAYMENT_METHOD_LIST_DATA_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.FETCH_PAYMENT_METHOD_LIST_DATA_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}
export function* fetchAllTemplateData() {
  yield takeEvery('FETCH_TEMPLATE_DATA', function* (payload) {
    try {
      yield put({
        type: actions.FETCHING_TEMPLATE_DATA,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader(payload);
      const apiResult = yield fetchAllTemplateDataAPI(payload.payload, roleHeaderAuth);

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.FETCH_TEMPLATE_DATA_SUCCESS,
          loading: false,
          result: result ? result.data : null
        });
      } else {
        yield put({
          type: actions.FETCH_TEMPLATE_DATA_FAILED,
          loading: false
        });
      }
    } catch (error) {
      yield put({
        type: actions.FETCH_TEMPLATE_DATA_FAILED,
        loading: false
      });
    }
  });
}

export function* fetchAllBankTemplateData() {
  yield takeEvery('FETCH_BANK_TEMPLATE_DATA', function* (payload) {
    try {
      yield put({
        type: actions.FETCHING_BANK_TEMPLATE_DATA,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader(payload);
      const apiResult = yield fetchAllBankTemplateDataAPI(payload.payload, roleHeaderAuth);

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.FETCH_BANK_TEMPLATE_DATA_SUCCESS,
          loading: false,
          result: result ? result.data : null
        });
      } else {
        yield put({
          type: actions.FETCH_BANK_TEMPLATE_DATA_FAILED,
          loading: false
        });
      }
    } catch (error) {
      yield put({
        type: actions.FETCH_BANK_TEMPLATE_DATA_FAILED,
        loading: false
      });
    }
  });
}
export function* addTemplateData() {
  yield takeEvery('ADD_TEMPLATE_DATA', function* ({ payload }) {
    try {
      yield put({
        type: actions.ADDING_TEMPLATE_DATA,
        loading: true
      });
      const state = yield select();
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield addTemplateDataAPI(payload, roleHeaderAuth);
      const paymentChannel = state.Tools.uploadedChannel.p_channel;

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.ADD_TEMPLATE_DATA_SUCCESS,
          loading: false,
          message: result.message
        });
        yield put({
          type: actions.FETCH_TEMPLATE_DATA,
          payload: { payment_channel: payload.code ? payload.code : null }
        });

        if (paymentChannel) {
          const logPagination = state.Tools.currentItemLogPagination
            ? state.Tools.currentItemLogPagination
            : { page: 0, limit: 10 };
          yield put({
            type: actions.FETCH_LOGS_BY_ITEM_ID,
            id: paymentChannel,
            payload: {
              pagination: logPagination
            }
          });
        }
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.ADD_TEMPLATE_DATA_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.ADD_TEMPLATE_DATA_FAILED,
            message: result.message,
            loading: false
          });
        }

        if (paymentChannel) {
          const logPagination = state.Tools.currentItemLogPagination
            ? state.Tools.currentItemLogPagination
            : { page: 0, limit: 10 };
          yield put({
            type: actions.FETCH_LOGS_BY_ITEM_ID,
            id: paymentChannel,
            payload: {
              pagination: logPagination
            }
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.ADD_TEMPLATE_DATA_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* addBankTemplateData() {
  yield takeEvery('ADD_BANK_TEMPLATE_DATA', function* ({ payload, id }) {
    try {
      yield put({
        type: actions.ADDING_BANK_TEMPLATE_DATA,
        loading: true
      });
      const state = yield select();
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield addBankTemplateDataAPI(payload, roleHeaderAuth);
      const activeUploadedBank = state.Transaction.activeUploadedBank;

      const result = apiResult.data;
      if (result.success) {
        yield put({
          type: actions.ADD_BANK_TEMPLATE_DATA_SUCCESS,
          loading: false,
          message: result.message
        });
        yield put({
          type: actions.FETCH_BANK_TEMPLATE_DATA,
          payload: { bank_code: id }
        });

        if (activeUploadedBank) {
          const logPagination = state.Tools.currentItemLogPagination
            ? state.Tools.currentItemLogPagination
            : { page: 0, limit: 10 };
          yield put({
            type: actions.FETCH_LOGS_BY_ITEM_ID,
            id: activeUploadedBank,
            payload: {
              pagination: logPagination
            }
          });
        }
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.ADD_BANK_TEMPLATE_DATA_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.ADD_BANK_TEMPLATE_DATA_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.ADD_TEMPLATE_DATA_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}
export function* editPaynamicsBankTemplateDetails() {
  yield takeEvery('EDIT_PAYNAMICS_BANK_TEMPLATE_DATA', function* ({ payload, id, code }) {
    try {
      yield put({
        type: actions.EDITING_PAYNAMICS_BANK_TEMPLATE_DATA,
        loading: true
      });
      const state = yield select();
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield editPaynamicsBankTemplateAPI(payload, id, roleHeaderAuth);
      const activeUploadedBank = state.Transaction.activeUploadedBank;

      const result = apiResult.data;
      if (result.success) {
        yield put({
          type: actions.EDIT_PAYNAMICS_BANK_TEMPLATE_DATA_SUCCESS,
          loading: false,
          message: result.message
        });
        yield put({
          type: actions.FETCH_BANK_TEMPLATE_DATA,
          payload: { bank_code: code }
        });
        if (activeUploadedBank) {
          const logPagination = state.Tools.currentItemLogPagination
            ? state.Tools.currentItemLogPagination
            : { page: 0, limit: 10 };
          yield put({
            type: actions.FETCH_LOGS_BY_ITEM_ID,
            id: activeUploadedBank,
            payload: {
              pagination: logPagination
            }
          });
        }
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.EDIT_PAYNAMICS_BANK_TEMPLATE_DATA_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.EDIT_PAYNAMICS_BANK_TEMPLATE_DATA_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.EDIT_PAYNAMICS_BANK_TEMPLATE_DATA_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}
export function* editTemplateData() {
  yield takeEvery('EDIT_TEMPLATE_DATA', function* ({ payload, id }) {
    try {
      yield put({
        type: actions.EDITING_TEMPLATE_DATA,
        loading: true
      });
      const state = yield select();
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield editTemplateDataAPI(payload, id, roleHeaderAuth);
      const paymentChannel = state.Tools.uploadedChannel.p_channel;

      const result = apiResult.data;
      if (result.success) {
        yield put({
          type: actions.EDIT_TEMPLATE_DATA_SUCCESS,
          loading: false,
          message: result.message
        });
        yield put({
          type: actions.FETCH_TEMPLATE_DATA,
          payload: { payment_channel: payload.code ? payload.code : null }
        });

        if (paymentChannel) {
          const logPagination = state.Tools.currentItemLogPagination
            ? state.Tools.currentItemLogPagination
            : { page: 0, limit: 10 };
          yield put({
            type: actions.FETCH_LOGS_BY_ITEM_ID,
            id: paymentChannel,
            payload: {
              pagination: logPagination
            }
          });
        }
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.EDIT_TEMPLATE_DATA_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.EDIT_TEMPLATE_DATA_FAILED,
            message: result.message,
            loading: false
          });
        }

        if (paymentChannel) {
          const logPagination = state.Tools.currentItemLogPagination
            ? state.Tools.currentItemLogPagination
            : { page: 0, limit: 10 };
          yield put({
            type: actions.FETCH_LOGS_BY_ITEM_ID,
            id: paymentChannel,
            payload: {
              pagination: logPagination
            }
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.EDIT_TEMPLATE_DATA_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}
export function* fetchAllUploadedFiles() {
  yield takeEvery('FETCH_UPLOADED_FILES', function* ({ payload }) {
    try {
      yield put({
        type: actions.FETCHING_UPLOADED_FILES,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield fetchAllUploadedFilesAPI(payload, roleHeaderAuth);

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.FETCH_UPLOADED_FILES_SUCCESS,
          loading: false,
          result: result ? result.data : null,
          pagination: result ? result.pagination : null,
          channel: payload
        });
      } else {
        yield put({
          type: actions.FETCH_UPLOADED_FILES_FAILED,
          loading: false
        });
      }
    } catch (error) {
      yield put({
        type: actions.FETCH_UPLOADED_FILES_FAILED,
        loading: false
      });
    }
  });
}
export function* uploadFileData() {
  yield takeEvery('UPLOAD_FILE_TRANSACTION_DATA', function* ({ url, payload, pagination }) {
    try {
      yield put({
        type: actions.UPLOADING_FILE_TRANSACTION_DATA,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const s3Bucket = yield uploadFileToS3(url, payload);
      const state = yield select();
      const uploadedChannel = state.Tools.uploadedChannel;
      const paymentChannel = uploadedChannel.p_channel;

      // if (s3Bucket && s3Bucket.status === 200 && uploadedChannel) {
      //   yield put({
      //     type: actions.FETCH_UPLOADED_FILES,
      //     payload: uploadedChannel
      //   });
      // }
      const apiResult =
        s3Bucket.status === 200
          ? yield uploadFileDataAPI(
              {
                template_id: payload.template_id,
                name: payload.name,
                module: payload.module,
                topic: payload.topic
              },
              roleHeaderAuth
            )
          : { data: { success: false } };
      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.UPLOAD_FILE_TRANSACTION_DATA_SUCCESS,
          loading: false,
          message: result.message
        });
        yield put({
          type: actions.FETCH_UPLOADED_FILES,
          payload: uploadedChannel
        });

        if (paymentChannel) {
          const logPagination = state.Tools.currentItemLogPagination
            ? state.Tools.currentItemLogPagination
            : { page: 0, limit: 10 };
          yield put({
            type: actions.FETCH_LOGS_BY_ITEM_ID,
            id: paymentChannel,
            payload: {
              pagination: logPagination
            }
          });
        }
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.UPLOAD_FILE_TRANSACTION_DATA_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else if (result.status === 413) {
          yield put({
            type: actions.UPLOAD_FILE_TRANSACTION_DATA_FAILED,
            message: `Your request exceeded the system limit size`,
            loading: false
          });
        } else {
          yield put({
            type: actions.UPLOAD_FILE_TRANSACTION_DATA_FAILED,
            message: result.message,
            loading: false
          });
        }

        if (paymentChannel) {
          const logPagination = state.Tools.currentItemLogPagination
            ? state.Tools.currentItemLogPagination
            : { page: 0, limit: 10 };
          yield put({
            type: actions.FETCH_LOGS_BY_ITEM_ID,
            id: paymentChannel,
            payload: {
              pagination: logPagination
            }
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.UPLOAD_FILE_TRANSACTION_DATA_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}
export function* uploadMultipleFileData() {
  yield takeEvery(
    'UPLOAD_MULTIPLE_FILE_TRANSACTION_DATA',
    function* ({ urls, payload, pagination }) {
      try {
        yield put({
          type: actions.UPLOADING_MULTIPLE_FILE_TRANSACTION_DATA,
          loading: true
        });
        const roleHeaderAuth = yield getRoleHeader();
        const state = yield select();
        const uploadedChannel = state.Tools.uploadedChannel;
        if (payload && payload.files.length === urls.length) {
          // let finalDataForUpload = processUploadingMultipleFiles(payload, urls);
          let finalDataForUpload = [];
          const dataFile = payload.files;

          // Track upload promises
          const uploadPromises = dataFile.map(async file => {
            // Check if the file has a corresponding URL
            const getURL = urls.find(str => str.includes(file.name));
            if (getURL) {
              try {
                // Upload file to S3 with progress monitoring
                await uploadFileToS3WithProgress(getURL, file, progress => {});

                // After upload, add metadata to the final data
                finalDataForUpload.push({
                  template_id: payload.template_id,
                  name: file.name,
                  module: payload.module,
                  topic: payload.topic
                });
              } catch (error) {
                console.error(`Error uploading file ${file.name}:`, error.message);
              }
            }
          });

          // Wait for all uploads to complete
          yield Promise.all(uploadPromises);

          if (finalDataForUpload && finalDataForUpload.length > 0) {
            const apiResult = yield uploadMultipleFileDataAPI(
              {
                files: finalDataForUpload,
                template_id: payload.template_id,
                file_password: payload.file_password,
                name: payload.name,
                module: payload.module,
                topic: payload.topic,
                notification_data: payload.notification_data
              },
              roleHeaderAuth
            );
            const result = apiResult.data;
            if (result.success) {
              yield put({
                type: actions.UPLOAD_MULTIPLE_FILE_TRANSACTION_DATA_SUCCESS,
                loading: false,
                message: result.message
              });
              yield put({
                type: actions.FETCH_UPLOADED_FILES,
                payload: uploadedChannel
              });
            } else {
              if (result.status === 404) {
                yield put({
                  type: actions.UPLOAD_MULTIPLE_FILE_TRANSACTION_DATA_FAILED,
                  message: `Endpoint ${result.title}`,
                  loading: false
                });
              } else if (result.status === 413) {
                yield put({
                  type: actions.UPLOAD_MULTIPLE_FILE_TRANSACTION_DATA_FAILED,
                  message: `Your request exceeded the system limit size`,
                  loading: false
                });
              } else {
                yield put({
                  type: actions.UPLOAD_MULTIPLE_FILE_TRANSACTION_DATA_FAILED,
                  message: result.message,
                  loading: false
                });
              }
            }
          } else {
            yield put({
              type: actions.UPLOAD_MULTIPLE_FILE_TRANSACTION_DATA_FAILED,
              message: `Files were failed to upload due to an connection issue. Please try again.`,
              loading: false
            });
          }
        } else {
          yield put({
            type: actions.UPLOAD_MULTIPLE_FILE_TRANSACTION_DATA_FAILED,
            message: 'Failed to upload multiple files at the same time. Please try again.',
            loading: false
          });
        }
      } catch (error) {
        yield put({
          type: actions.UPLOAD_MULTIPLE_FILE_TRANSACTION_DATA_FAILED,
          message: 'Failed to process request',
          loading: false
        });
      }
    }
  );
}

export function* uploadLeadsFileData() {
  yield takeEvery('UPLOAD_LEADS_FILE_DATA', function* ({ urls, payload }) {
    try {
      yield put({
        type: actions.UPLOADING_LEADS_FILE_DATA,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      if (payload && payload.files.length === urls.length) {
        let finalDataForUpload = [];
        const dataFile = payload.files;
        dataFile.forEach(file => {
          if (urls.some(str => str.includes(file.name))) {
            let getURL = urls.find(str => str.includes(file.name));
            if (getURL) {
              uploadFileToS3(getURL, file);
              let currentObj = {
                template_id: payload.template_id,
                name: file.name,
                module: payload.module,
                topic: payload.topic
              };
              finalDataForUpload.push(currentObj);
            }
          }
        });

        yield delay(urls.length * 1000);

        if (finalDataForUpload && finalDataForUpload.length > 0) {
          const apiResult = yield uploadLeadsFileDataAPI(
            {
              files: finalDataForUpload,
              name: payload.name,
              module: payload.module,
              topic: payload.topic,
              notification_data: payload.notification_data,
              template_id: payload.template_id
            },
            roleHeaderAuth
          );
          const result = apiResult.data;
          if (result.success) {
            yield put({
              type: actions.UPLOAD_LEADS_FILE_DATA_SUCCESS,
              loading: false,
              message: result.message
            });
          } else {
            if (result.status === 404) {
              yield put({
                type: actions.UPLOAD_LEADS_FILE_DATA_FAILED,
                message: `Endpoint ${result.title}`,
                loading: false
              });
            } else if (result.status === 413) {
              yield put({
                type: actions.UPLOAD_LEADS_FILE_DATA_FAILED,
                message: `Your request exceeded the system limit size`,
                loading: false
              });
            } else {
              yield put({
                type: actions.UPLOAD_LEADS_FILE_DATA_FAILED,
                message: result.message,
                loading: false
              });
            }
          }
        } else {
          yield put({
            type: actions.UPLOAD_LEADS_FILE_DATA_FAILED,
            message: `Files were failed to upload due to an connection issue. Please try again.`,
            loading: false
          });
        }
      } else {
        yield put({
          type: actions.UPLOAD_LEADS_FILE_DATA_FAILED,
          message: 'Failed to upload multiple files at the same time. Please try again.',
          loading: false
        });
      }
    } catch (error) {
      yield put({
        type: actions.UPLOAD_LEADS_FILE_DATA_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* reuploadLeadsFileData() {
  yield takeEvery('REUPLOAD_LEADS_FILE_DATA', function* ({ urls, payload }) {
    try {
      yield put({
        type: actions.REUPLOADING_LEADS_FILE_DATA,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();

      if (payload && payload.files.length === urls.length) {
        let finalDataForUpload = [];
        const dataFile = payload.files;
        dataFile.forEach(file => {
          if (urls.some(str => str.includes(file.name))) {
            let getURL = urls.find(str => str.includes(file.name));
            if (getURL) {
              uploadFileToS3(getURL, file);
              let currentObj = {
                template_id: payload.template_id,
                name: file.name,
                module: payload.module,
                topic: payload.topic
              };
              finalDataForUpload.push(currentObj);
            }
          }
        });

        yield delay(urls.length * 1000);

        if (finalDataForUpload && finalDataForUpload.length > 0) {
          const apiResult = yield reuploadLeadsFileDataAPI(payload, roleHeaderAuth);
          const result = apiResult.data;
          if (result.success) {
            yield put({
              type: actions.REUPLOAD_LEADS_FILE_DATA_SUCCESS,
              loading: false,
              message: result.message
            });
          } else {
            if (result.status === 404) {
              yield put({
                type: actions.REUPLOAD_LEADS_FILE_DATA_FAILED,
                message: `Endpoint ${result.title}`,
                loading: false
              });
            } else if (result.status === 413) {
              yield put({
                type: actions.REUPLOAD_LEADS_FILE_DATA_FAILED,
                message: `Your request exceeded the system limit size`,
                loading: false
              });
            } else {
              yield put({
                type: actions.REUPLOAD_LEADS_FILE_DATA_FAILED,
                message: result.message,
                loading: false
              });
            }
          }
        } else {
          yield put({
            type: actions.REUPLOAD_LEADS_FILE_DATA_FAILED,
            message: `Files were failed to upload due to an connection issue. Please try again.`,
            loading: false
          });
        }
      } else {
        yield put({
          type: actions.REUPLOAD_LEADS_FILE_DATA_FAILED,
          message: 'Failed to upload multiple files at the same time. Please try again.',
          loading: false
        });
      }
    } catch (error) {
      yield put({
        type: actions.REUPLOAD_LEADS_FILE_DATA_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* uploadBankTrxData() {
  yield takeEvery('UPLOAD_BANK_TRX_DATA', function* ({ url, payload }) {
    try {
      yield put({
        type: actions.UPLOADING_BANK_TRX_DATA,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const s3Bucket = yield uploadFileToS3(url, payload);
      const state = yield select();
      const activeUploadedBank = state.Transaction.activeUploadedBank;
      const apiResult =
        s3Bucket.status === 200
          ? yield uploadBankTrxDataAPI(
              {
                template_id: payload.template_id,
                name: payload.name,
                trx_date: payload.trx_date ? payload.trx_date : null,
                module: payload.module,
                topic: payload.topic
              },
              roleHeaderAuth
            )
          : { data: { success: false } };
      const result = apiResult.data;
      if (result.success) {
        yield put({
          type: actions.UPLOAD_BANK_TRX_DATA_SUCCESS,
          loading: false,
          message: result.message
        });
        yield put({
          type: trxActions.FETCH_UPLOADED_BANK_FILES,
          payload: { bank_id: activeUploadedBank }
        });
        if (activeUploadedBank) {
          const logPagination = state.Tools.currentItemLogPagination
            ? state.Tools.currentItemLogPagination
            : { page: 0, limit: 10 };

          yield put({
            type: actions.FETCH_LOGS_BY_ITEM_ID,
            id: activeUploadedBank,
            payload: {
              pagination: logPagination
            }
          });
        }
      } else {
        if (activeUploadedBank) {
          const logPagination = state.Tools.currentItemLogPagination
            ? state.Tools.currentItemLogPagination
            : { page: 0, limit: 10 };

          yield put({
            type: actions.FETCH_LOGS_BY_ITEM_ID,
            id: activeUploadedBank,
            payload: {
              pagination: logPagination
            }
          });
        }

        if (result.status === 404) {
          yield put({
            type: actions.UPLOAD_BANK_TRX_DATA_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else if (result.status === 413) {
          yield put({
            type: actions.UPLOAD_BANK_TRX_DATA_FAILED,
            message: `Your request exceeded the system limit size`,
            loading: false
          });
        } else {
          yield put({
            type: actions.UPLOAD_BANK_TRX_DATA_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.UPLOAD_BANK_TRX_DATA_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* reuploadBankTrxData() {
  yield takeEvery(actions.REUPLOAD_BANK_TRX_DATA, function* ({ url, payload }) {
    try {
      yield put({
        type: actions.REUPLOADING_BANK_TRX_DATA,
        loading: true
      });

      const roleHeaderAuth = yield getRoleHeader();
      const deleteApiResult = yield deleteBankTrxDataAPI(payload.id, roleHeaderAuth);

      if (!deleteApiResult || !deleteApiResult.data?.success) {
        yield put ({
          type: actions.REUPLOAD_BANK_TRX_DATA_FAILED,
          message: 'Failed to delete existing bank transaction data',
          loading: false
        });
        return;
      }
      
      const s3Bucket = yield uploadFileToS3(url, payload);
      
      if (s3Bucket.status !== 200) {
        yield put({
          type: actions.REUPLOAD_BANK_TRX_DATA_FAILED,
          message: 'Failed to upload file to S3',
          loading: false
        });
        return;
      }
      
      const state = yield select();
      const activeUploadedBank = state.Transaction.activeUploadedBank;
      const bankApiResult = yield uploadBankTrxDataAPI(
        {
          template_id: payload.template_id,
          name: payload.name,
          trx_date: payload.trx_date ? payload.trx_date : null,
          module: payload.module,
          topic: payload.topic
        },
        roleHeaderAuth
      );

      const result = bankApiResult.data;
      if (result.success) {
        yield put({
          type: actions.REUPLOAD_BANK_TRX_DATA_SUCCESS,
          loading: false,
          message: "File is successfully reuploaded. Parsing of file process is ongoing"
        });
        yield put({
          type: trxActions.FETCH_UPLOADED_BANK_FILES,
          payload: { bank_id: activeUploadedBank }
        });
        if (activeUploadedBank) {
          const logPagination = state.Tools.currentItemLogPagination
            ? state.Tools.currentItemLogPagination
            : { page: 0, limit: 10 };

          yield put({
            type: actions.FETCH_LOGS_BY_ITEM_ID,
            id: activeUploadedBank,
            payload: {
              pagination: logPagination
            }
          });
        }
      } else {
        if (activeUploadedBank) {
          const logPagination = state.Tools.currentItemLogPagination
            ? state.Tools.currentItemLogPagination
            : { page: 0, limit: 10 };

          yield put({
            type: actions.FETCH_LOGS_BY_ITEM_ID,
            id: activeUploadedBank,
            payload: {
              pagination: logPagination
            }
          });
        }

        if (result.status === 404) {
          yield put({
            type: actions.REUPLOAD_BANK_TRX_DATA_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else if (result.status === 413) {
          yield put({
            type: actions.REUPLOAD_BANK_TRX_DATA_FAILED,
            message: `Your request exceeded the system limit size`,
            loading: false
          });
        } else {
          yield put({
            type: actions.REUPLOAD_BANK_TRX_DATA_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.REUPLOAD_BANK_TRX_DATA_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* reuploadFileData() {
  yield takeEvery('REUPLOAD_FILE_TRANSACTION_DATA', function* ({ url, payload, pagination }) {
    try {
      yield put({
        type: actions.REUPLOADING_FILE_TRANSACTION_DATA,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const s3Bucket = yield reuploadFileToS3(url, payload);
      const state = yield select();
      const uploadedChannel = state.Tools.uploadedChannel;
      const paymentChannel = uploadedChannel.p_channel;

      if (s3Bucket && s3Bucket.status === 200 && uploadedChannel) {
        yield put({
          type: actions.FETCH_UPLOADED_FILES,
          payload: uploadedChannel
        });
      }
      const apiResult =
        s3Bucket.status === 200
          ? yield reuploadFileDataAPI(
              payload.id,
              {
                template_id: payload.template_id,
                name: payload.name,
                module: payload.module,
                topic: payload.topic,
                notification_data: payload.notification_data
              },
              roleHeaderAuth
            )
          : { data: { success: false } };
      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.REUPLOAD_FILE_TRANSACTION_DATA_SUCCESS,
          loading: false,
          message: result.message
        });

        if (paymentChannel) {
          const logPagination = state.Tools.currentItemLogPagination
            ? state.Tools.currentItemLogPagination
            : { page: 0, limit: 10 };
          yield put({
            type: actions.FETCH_LOGS_BY_ITEM_ID,
            id: paymentChannel,
            payload: {
              pagination: logPagination
            }
          });
        }
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.REUPLOAD_FILE_TRANSACTION_DATA_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else if (result.status === 413) {
          yield put({
            type: actions.REUPLOAD_FILE_TRANSACTION_DATA_FAILED,
            message: `Your request exceeded the system limit size`,
            loading: false
          });
        } else {
          yield put({
            type: actions.REUPLOAD_FILE_TRANSACTION_DATA_FAILED,
            message: result.message,
            loading: false
          });
        }

        if (paymentChannel) {
          const logPagination = state.Tools.currentItemLogPagination
            ? state.Tools.currentItemLogPagination
            : { page: 0, limit: 10 };
          yield put({
            type: actions.FETCH_LOGS_BY_ITEM_ID,
            id: paymentChannel,
            payload: {
              pagination: logPagination
            }
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.REUPLOAD_FILE_TRANSACTION_DATA_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}
export function* getPreSignedURL() {
  yield takeEvery('GET_PRE_SIGNED_URL', function* ({ filename }) {
    try {
      yield put({
        type: actions.GETTING_PRE_SIGNED_URL,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield getPreSignedURLAPI(filename, roleHeaderAuth);

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.GET_PRE_SIGNED_URL_SUCCESS,
          loading: false,
          result: result ? result.data : null
        });
      } else {
        yield put({
          type: actions.GET_PRE_SIGNED_URL_FAILED,
          loading: false
        });
      }
    } catch (error) {
      yield put({
        type: actions.GET_PRE_SIGNED_URL_FAILED,
        loading: false
      });
    }
  });
}
export function* getPresignedURLWithKey() {
  yield takeEvery('GET_PRE_SIGNED_URL_WITH_KEY', function* ({ filename }) {
    try {
      yield put({
        type: actions.GETTING_PRE_SIGNED_URL_WITH_KEY,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield getPresignedURLWithKeyAPI(filename, roleHeaderAuth);

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.GET_PRE_SIGNED_URL_WITH_KEY_SUCCESS,
          loading: false,
          result: result ? result.data : null
        });
      } else {
        yield put({
          type: actions.GET_PRE_SIGNED_URL_WITH_KEY_FAILED,
          loading: false
        });
      }
    } catch (error) {
      yield put({
        type: actions.GET_PRE_SIGNED_URL_WITH_KEY_FAILED,
        loading: false
      });
    }
  });
}
export function* getMultiplePresignedURL() {
  yield takeEvery('GET_LIST_OF_PRE_SIGNED_URL', function* ({ files }) {
    try {
      yield put({
        type: actions.GETTING_LIST_OF_PRE_SIGNED_URL,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield getMultiplePreSignedURLAPI(files, roleHeaderAuth);

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.GET_LIST_OF_PRE_SIGNED_URL_SUCCESS,
          loading: false,
          result: result ? result.data : null
        });
      } else {
        yield put({
          type: actions.GET_LIST_OF_PRE_SIGNED_URL_FAILED,
          loading: false
        });
      }
    } catch (error) {
      yield put({
        type: actions.GET_LIST_OF_PRE_SIGNED_URL_FAILED,
        loading: false
      });
    }
  });
}
export function* fetchAllCosmosLogs() {
  yield takeEvery('FETCH_COSMOS_LOGS', function* ({ payload }) {
    try {
      yield put({
        type: actions.FETCHING_COSMOS_LOGS,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield fetchAllCosmosLogsAPI( payload, roleHeaderAuth);

      const result = apiResult.data;

      const logs = result?.data;
      const newLogs = logs?.map(log => {
        const value = typeof log.value === 'string' ? log.value : JSON.stringify(log.value);
        return { ...log, value };
      });

      if (result.success) {
        yield put({
          type: actions.FETCH_COSMOS_LOGS_SUCCESS,
          loading: false,
          result: result && newLogs ? newLogs : [],
          pagination: result.pagination ? result.pagination : null,
          filter: payload
        });
      } else {
        yield put({
          type: actions.FETCH_COSMOS_LOGS_FAILED,
          loading: false
        });
      }
    } catch (error) {
      yield put({
        type: actions.FETCH_COSMOS_LOGS_FAILED,
        loading: false
      });
    }
  });
}
export function* fetchAllPaynamicsBanks() {
  yield takeEvery('FETCH_PAYNAMICS_BANK_DATA', function* () {
    try {
      yield put({
        type: actions.FETCHING_PAYNAMICS_BANK_DATA,
        loading: true
      });

      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield fetchPaynamicsBanksDataAPI(roleHeaderAuth);

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.FETCH_PAYNAMICS_BANK_DATA_SUCCESS,
          loading: false,
          result: result ? result.data : []
        });
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.FETCH_PAYNAMICS_BANK_DATA_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.FETCH_PAYNAMICS_BANK_DATA_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.FETCH_PAYNAMICS_BANK_DATA_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* addPaynamicsBank() {
  yield takeEvery('ADD_PAYNAMICS_BANK', function* ({ payload }) {
    try {
      yield put({
        type: actions.ADDING_PAYNAMICS_BANK,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield addPaynamicsBankAPI(payload, roleHeaderAuth);

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.ADD_PAYNAMICS_BANK_SUCCESS,
          loading: false,
          message: result.message
        });
        yield put({
          type: actions.FETCH_PAYNAMICS_BANK_DATA
        });
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.ADD_PAYNAMICS_BANK_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.ADD_PAYNAMICS_BANK_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.ADD_PAYNAMICS_BANK_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* editPaynamicsBank() {
  yield takeEvery('EDIT_PAYNAMICS_BANK', function* ({ id, payload }) {
    try {
      yield put({
        type: actions.EDITING_PAYNAMICS_BANK,
        loading: true
      });
      const state = yield select();
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield editPaynamicsBankAPI(id, payload, roleHeaderAuth);

      const pagination = state.Tools.currentItemLogPagination
        ? state.Tools.currentItemLogPagination
        : { page: 0, limit: 10 };

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.EDIT_PAYNAMICS_BANK_SUCCESS,
          loading: false,
          message: result.message
        });
        yield put({
          type: actions.RESET_PAYNAMICS_BANK_DATA
        });
        yield put({
          type: actions.FETCH_PAYNAMICS_BANK_DATA
        });
        yield put({
          type: actions.FETCH_LOGS_BY_ITEM_ID,
          id,
          payload: {
            pagination
          }
        });
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.EDIT_PAYNAMICS_BANK_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.EDIT_PAYNAMICS_BANK_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.EDIT_PAYNAMICS_BANK_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* fetchAllSystemSettings() {
  yield takeEvery('FETCH_SYSTEM_SETTINGS', function* () {
    try {
      yield put({
        type: actions.FETCHING_SYSTEM_SETTINGS,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield fetchAllSystemSettingsAPI(roleHeaderAuth);

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.FETCH_SYSTEM_SETTINGS_SUCCESS,
          loading: false,
          result: result && result.data ? result.data : []
        });
      } else {
        yield put({
          type: actions.FETCH_SYSTEM_SETTINGS_FAILED,
          loading: false
        });
      }
    } catch (error) {
      yield put({
        type: actions.FETCH_SYSTEM_SETTINGS_FAILED,
        loading: false
      });
    }
  });
}
export function* inviteUserData() {
  yield takeEvery('INVITE_USER_DATA', function* ({ payload }) {
    try {
      yield put({
        type: actions.INVITING_USER_DATA,
        loading: true
      });
      const state = yield select();
      const userPagination = state.Tools.userPagination;
      const userData = state.Tools.userData;
      const userFilter = state.Tools.userFilter;
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield inviteUserDataAPI(payload, roleHeaderAuth);

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.INVITE_USER_DATA_SUCCESS,
          loading: false,
          message: result.message,
          result: result ? result.data : null
        });
        yield put({
          type: actions.FETCH_USER_DATA,
          payload: {
            ...userFilter,
            pagination: {
              page: userPagination.current_page,
              limit: userPagination.page_size,
              loadMore: userPagination.current_page >= 1,
              currentUserList: userData
            }
          }
        });
      } else {
        yield put({
          type: actions.INVITE_USER_DATA_FAILED,
          message: result.message,
          loading: false
        });
      }
    } catch (error) {
      yield put({
        type: actions.INVITE_USER_DATA_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* resendInviteUserData() {
  yield takeEvery('RESEND_INVITE_USER_DATA', function* ({ payload }) {
    try {
      yield put({
        type: actions.RESEND_INVITING_USER_DATA,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield resendInviteUserDataAPI(payload, roleHeaderAuth);

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.RESEND_INVITE_USER_DATA_SUCCESS,
          loading: false,
          message: result.message,
          result: result ? result.data : null
        });
        yield put({
          type: actions.FETCH_ALL_INVITED_USERS_DATA,
          payload: {},
          pagination: {
            page: 0,
            limit: 20
          }
        });
      } else {
        yield put({
          type: actions.RESEND_INVITE_USER_DATA_FAILED,
          message: 'Failed to process request',
          loading: false
        });
      }
    } catch (error) {
      yield put({
        type: actions.RESEND_INVITE_USER_DATA_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* fetchInvitedUserDetails() {
  yield takeEvery('FETCH_INVITED_USER_DATA', function* ({ payload }) {
    try {
      yield put({
        type: actions.FETCHING_INVITED_USER_DATA,
        loading: true
      });

      const apiResult = yield fetchInvitedUserDataAPI(payload);
      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.FETCH_INVITED_USER_DATA_SUCCESS,
          loading: false,
          result: result ? result.data : null
        });
      } else {
        yield put({
          type: actions.FETCH_INVITED_USER_DATA_FAILED,
          loading: false,
          result: []
        });
      }
    } catch (error) {
      yield put({
        type: actions.FETCH_INVITED_USER_DATA_FAILED,
        payload: [],
        loading: false
      });
    }
  });
}

export function* logAccessInvite() {
  yield takeEvery('LOG_ACCESS_INVITE_DATA', function* ({ id }) {
    try {
      yield put({
        type: actions.LOGGING_ACCESS_INVITE_DATA,
        loading: true
      });
      const apiResult = yield logAccessInviteAPI(id);

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.LOG_ACCESS_INVITE_DATA_SUCCESS,
          loading: false,
          message: result.message,
          result: result ? result.data : null
        });
      } else {
        yield put({
          type: actions.LOG_ACCESS_INVITE_DATA_FAILED,
          message: 'Failed to process request',
          loading: false
        });
      }
    } catch (error) {
      yield put({
        type: actions.LOG_ACCESS_INVITE_DATA_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* fetchAllInvitedUsersData() {
  yield takeEvery('FETCH_ALL_INVITED_USERS_DATA', function* ({ payload }) {
    try {
      yield put({
        type: actions.FETCHING_ALL_INVITED_USERS_DATA,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield fetchAllInvitedUsersDataAPI(payload, roleHeaderAuth);

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.FETCH_ALL_INVITED_USERS_DATA_SUCCESS,
          loading: false,
          result: result ? result.data : null,
          pagination: result ? result.pagination : null
        });
      } else {
        yield put({
          type: actions.FETCH_ALL_INVITED_USERS_DATA_FAILED,
          loading: false
        });
      }
    } catch (error) {
      yield put({
        type: actions.FETCH_ALL_INVITED_USERS_DATA_FAILED,
        loading: false
      });
    }
  });
}

export function* signUpUserData() {
  yield takeEvery('SIGN_UP_USER_DATA', function* ({ payload }) {
    try {
      yield put({
        type: actions.SIGNING_UP_USER_DATA,
        loading: true
      });

      const apiResult = yield signUpUserDataAPI(payload);

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.SIGN_UP_USER_DATA_SUCCESS,
          loading: false,
          message: result.message,
          result: result ? result.data : null
        });
      } else {
        yield put({
          type: actions.SIGN_UP_USER_DATA_FAILED,
          message: result.message,
          loading: false
        });
      }
    } catch (error) {
      yield put({
        type: actions.SIGN_UP_USER_DATA_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* addSystemSettings() {
  yield takeEvery('ADD_SYSTEM_SETTINGS', function* ({ payload }) {
    try {
      yield put({
        type: actions.ADDING_SYSTEM_SETTINGS,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield addSystemSettingsAPI(payload, roleHeaderAuth);
      const result = apiResult.data;
      if (result.success) {
        yield put({
          type: actions.ADD_SYSTEM_SETTINGS_SUCCESS,
          loading: false,
          message: result.message
        });
        yield put({
          type: actions.FETCH_SYSTEM_SETTINGS
        });
      } else {
        yield put({
          type: actions.ADD_SYSTEM_SETTINGS_FAILED,
          message: result.message,
          loading: false
        });
      }
    } catch (error) {
      yield put({
        type: actions.ADD_SYSTEM_SETTINGS_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* editSystemSettings() {
  yield takeEvery('EDIT_SYSTEM_SETTINGS', function* ({ payload, modules }) {
    try {
      yield put({
        type: actions.EDITING_SYSTEM_SETTINGS,
        loading: true
      });
      const state = yield select();
      const identity = state.Auth.identity;
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield editSystemSettingsAPI(payload, roleHeaderAuth);

      const result = apiResult.data;
      if (result.success) {
        if (payload.group === 'OTP_SETTINGS') {
          yield localStorage.setItem(
            'identity',
            JSON.stringify({ ...identity, global_otp: payload.value })
          );
          yield put({
            type: authActions.UPDATE_IDENTITY,
            payload: {
              ...identity,
              global_otp: payload.value
            }
          });
        }
        yield put({
          type: actions.EDIT_SYSTEM_SETTINGS_SUCCESS,
          loading: false,
          message: result.message
        });
        yield put({
          type: actions.FETCH_SYSTEM_SETTINGS
        });
        // window.location.reload();
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.EDIT_SYSTEM_SETTINGS_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.EDIT_SYSTEM_SETTINGS_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.EDIT_SYSTEM_SETTINGS_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}
export function* fetchLogsByItemId() {
  yield takeEvery('FETCH_LOGS_BY_ITEM_ID', function* ({ id, payload }) {
    try {
      yield put({
        type: actions.FETCHING_LOGS_BY_ITEM_ID,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield fetchLogsByItemIdAPI(id, payload, roleHeaderAuth);

      const result = apiResult.data;

      const logs = result?.data;
      const newLogs = logs?.map(log => {
        const value = typeof log.value === 'string' ? log.value : JSON.stringify(log.value);
        return { ...log, value };
      });

      if (result.success) {
        yield put({
          type: actions.FETCH_LOGS_BY_ITEM_ID_SUCCESS,
          loading: false,
          result: result && newLogs ? newLogs : [],
          pagination: result && result.pagination ? result.pagination : {}
        });
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.FETCH_LOGS_BY_ITEM_ID_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.FETCH_LOGS_BY_ITEM_ID_FAILED,
            message: 'Failed to process request',
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.FETCH_LOGS_BY_ITEM_ID_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}
export function* addNewPageAction() {
  yield takeEvery('ADD_PAGE_ACTION', function* ({ payload }) {
    try {
      yield put({
        type: actions.ADDING_PAGE_ACTION,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield addPageActionAPI(payload, roleHeaderAuth);

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.ADD_PAGE_ACTION_SUCCESS,
          loading: false,
          message: result.message
        });
        yield put({
          type: actions.FETCH_MODULE_DATA
        });
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.ADD_PAGE_ACTION_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.ADD_PAGE_ACTION_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.ADD_PAGE_ACTION_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}
export function* editPageAction() {
  yield takeEvery('EDIT_PAGE_ACTION', function* ({ payload, id }) {
    try {
      yield put({
        type: actions.EDITING_PAGE_ACTION,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield editPageActionAPI(payload, id, roleHeaderAuth);

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.EDIT_PAGE_ACTION_SUCCESS,
          loading: false,
          message: result.message
        });
        yield put({
          type: actions.FETCH_MODULE_DATA
        });
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.EDIT_PAGE_ACTION_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.EDIT_PAGE_ACTION_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.EDIT_PAGE_ACTION_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* editPaymentChannel() {
  yield takeEvery('EDIT_PAYMENT_CHANNEL_DATA', function* ({ payload, id }) {
    try {
      yield put({
        type: actions.EDITING_PAYMENT_CHANNEL_DATA,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield editPaymentChannelDataAPI(payload, id, roleHeaderAuth);

      const result = apiResult.data;
      if (result.success) {
        yield put({
          type: actions.EDIT_PAYMENT_CHANNEL_DATA_SUCCESS,
          loading: false,
          message: result.message
        });
        yield put({
          type: actions.FETCH_PCHANNEL_DATA
        });
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.EDIT_PAYMENT_CHANNEL_DATA_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.EDIT_PAYMENT_CHANNEL_DATA_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.EDIT_PAYMENT_CHANNEL_DATA_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* editNotifSetting() {
  yield takeEvery('EDIT_NOTIFICATION_SETTING', function* ({ payload, id }) {
    try {
      yield put({
        type: actions.EDITING_NOTIFICATION_SETTING,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield editNotifSettingAPI(payload, id, roleHeaderAuth);

      const result = apiResult.data;
      if (result.success) {
        yield put({
          type: actions.EDIT_NOTIFICATION_SETTING_SUCCESS,
          loading: false,
          message: result.message
        });
        yield put({
          type: actions.FETCH_NOTIFICATION_DATA
        });
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.EDIT_NOTIFICATION_SETTING_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.EDIT_NOTIFICATION_SETTING_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.EDIT_NOTIFICATION_SETTING_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* addPaymentChannelPayload() {
  yield takeEvery('ADD_PAYMENT_CHANNEL_PAYLOAD', function* ({ payload, id }) {
    try {
      yield put({
        type: actions.ADDING_PAYMENT_CHANNEL_PAYLOAD,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield addPaymentChannelPayloadAPI(payload, id, roleHeaderAuth);

      const result = apiResult.data;
      if (result.success) {
        yield put({
          type: actions.ADD_PAYMENT_CHANNEL_PAYLOAD_SUCCESS,
          loading: false,
          message: result.message,
          result: result ? result.data : null
        });
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.ADD_PAYMENT_CHANNEL_PAYLOAD_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.ADD_PAYMENT_CHANNEL_PAYLOAD_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.ADD_PAYMENT_CHANNEL_PAYLOAD_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* fetchPaymentChannelPayloadByID() {
  yield takeEvery('FETCH_PAYMENT_CHANNEL_PAYLOAD_BY_ID', function* ({ payload }) {
    try {
      yield put({
        type: actions.FETCHING_PAYMENT_CHANNEL_PAYLOAD_BY_ID,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield fetchPaymentChannelPayloadByIdAPI(payload, roleHeaderAuth);

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.FETCH_PAYMENT_CHANNEL_PAYLOAD_BY_ID_SUCCESS,
          loading: false,
          message: result.message,
          result: result ? result.data : null
        });
      } else {
        yield put({
          type: actions.FETCH_PAYMENT_CHANNEL_PAYLOAD_BY_ID_FAILED,
          message: result.message,
          loading: false
        });
      }
    } catch (error) {
      yield put({
        type: actions.FETCH_PAYMENT_CHANNEL_PAYLOAD_BY_ID_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* updatePaymentChannelPayload() {
  yield takeEvery('UPDATE_PAYMENT_CHANNEL_PAYLOAD', function* ({ payload, id }) {
    try {
      yield put({
        type: actions.UPDATING_PAYMENT_CHANNEL_PAYLOAD,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield updatePaymentChannelPayloadAPI(payload, id, roleHeaderAuth);

      const result = apiResult.data;
      if (result.success) {
        yield put({
          type: actions.UPDATE_PAYMENT_CHANNEL_PAYLOAD_SUCCESS,
          loading: false,
          message: result.message,
          result: result ? result.data : null
        });
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.UPDATE_PAYMENT_CHANNEL_PAYLOAD_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.UPDATE_PAYMENT_CHANNEL_PAYLOAD_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.UPDATE_PAYMENT_CHANNEL_PAYLOAD_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* addInstallmentModePayload() {
  yield takeEvery('ADD_INSTALLMENT_MODE_PAYLOAD', function* ({ payload, id }) {
    try {
      yield put({
        type: actions.ADDING_INSTALLMENT_MODE_PAYLOAD,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield addInstallmentModePayloadAPI(payload, id, roleHeaderAuth);

      const result = apiResult.data;
      if (result.success) {
        yield put({
          type: actions.ADD_INSTALLMENT_MODE_PAYLOAD_SUCCESS,
          loading: false,
          message: result.message,
          result: result ? result.data : null
        });
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.ADD_INSTALLMENT_MODE_PAYLOAD_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.ADD_INSTALLMENT_MODE_PAYLOAD_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.ADD_INSTALLMENT_MODE_PAYLOAD_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* fetchInstallmentModePayloadByID() {
  yield takeEvery('FETCH_INSTALLMENT_MODE_PAYLOAD_BY_ID', function* ({ payload }) {
    try {
      yield put({
        type: actions.FETCHING_INSTALLMENT_MODE_PAYLOAD_BY_ID,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield fetchInstallmentModePayloadByIdAPI(payload, roleHeaderAuth);

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.FETCH_INSTALLMENT_MODE_PAYLOAD_BY_ID_SUCCESS,
          loading: false,
          message: result.message,
          result: result ? result.data : null
        });
      } else {
        yield put({
          type: actions.FETCH_INSTALLMENT_MODE_PAYLOAD_BY_ID_FAILED,
          message: result.message,
          loading: false
        });
      }
    } catch (error) {
      yield put({
        type: actions.FETCH_INSTALLMENT_MODE_PAYLOAD_BY_ID_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* updateInstallmentModePayload() {
  yield takeEvery('UPDATE_INSTALLMENT_MODE_PAYLOAD', function* ({ payload, id }) {
    try {
      yield put({
        type: actions.UPDATING_INSTALLMENT_MODE_PAYLOAD,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield updateInstallmentModePayloadAPI(payload, id, roleHeaderAuth);

      const result = apiResult.data;
      if (result.success) {
        yield put({
          type: actions.UPDATE_INSTALLMENT_MODE_PAYLOAD_SUCCESS,
          loading: false,
          message: result.message,
          result: result ? result.data : null
        });
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.UPDATE_INSTALLMENT_MODE_PAYLOAD_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.UPDATE_INSTALLMENT_MODE_PAYLOAD_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.UPDATE_INSTALLMENT_MODE_PAYLOAD_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* addInstallmentTenorPayload() {
  yield takeEvery('ADD_INSTALLMENT_TENOR_PAYLOAD', function* ({ payload, id }) {
    try {
      yield put({
        type: actions.ADDING_INSTALLMENT_TENOR_PAYLOAD,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield addInstallmentTenorPayloadAPI(payload, id, roleHeaderAuth);

      const result = apiResult.data;
      if (result.success) {
        yield put({
          type: actions.ADD_INSTALLMENT_TENOR_PAYLOAD_SUCCESS,
          loading: false,
          message: result.message,
          result: result ? result.data : null
        });
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.ADD_INSTALLMENT_TENOR_PAYLOAD_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.ADD_INSTALLMENT_TENOR_PAYLOAD_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.ADD_INSTALLMENT_TENOR_PAYLOAD_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* updateInstallmentTenorPayload() {
  yield takeEvery('UPDATE_INSTALLMENT_TENOR_PAYLOAD', function* ({ payload, id }) {
    try {
      yield put({
        type: actions.UPDATING_INSTALLMENT_TENOR_PAYLOAD,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield updateInstallmentTenorPayloadAPI(payload, id, roleHeaderAuth);

      const result = apiResult.data;
      if (result.success) {
        yield put({
          type: actions.UPDATE_INSTALLMENT_TENOR_PAYLOAD_SUCCESS,
          loading: false,
          message: result.message,
          result: result ? result.data : null
        });
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.UPDATE_INSTALLMENT_TENOR_PAYLOAD_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.UPDATE_INSTALLMENT_TENOR_PAYLOAD_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.UPDATE_INSTALLMENT_TENOR_PAYLOAD_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* addSubChannelPayload() {
  yield takeEvery('ADD_SUB_CHANNEL_PAYLOAD', function* ({ payload, id }) {
    try {
      yield put({
        type: actions.ADDING_SUB_CHANNEL_PAYLOAD,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield addSubChannelPayloadAPI(payload, id, roleHeaderAuth);

      const result = apiResult.data;
      if (result.success) {
        yield put({
          type: actions.ADD_SUB_CHANNEL_PAYLOAD_SUCCESS,
          loading: false,
          message: result.message,
          result: result ? result.data : null
        });
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.ADD_SUB_CHANNEL_PAYLOAD_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.ADD_SUB_CHANNEL_PAYLOAD_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.ADD_SUB_CHANNEL_PAYLOAD_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* fetchSubChannelPayloadByID() {
  yield takeEvery('FETCH_SUB_CHANNEL_PAYLOAD_BY_ID', function* ({ payload }) {
    try {
      yield put({
        type: actions.FETCHING_SUB_CHANNEL_PAYLOAD_BY_ID,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield fetchSubChannelPayloadByIdAPI(payload, roleHeaderAuth);

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.FETCH_SUB_CHANNEL_PAYLOAD_BY_ID_SUCCESS,
          loading: false,
          message: result.message,
          result: result ? result.data : null
        });
      } else {
        yield put({
          type: actions.FETCH_SUB_CHANNEL_PAYLOAD_BY_ID_FAILED,
          message: result.message,
          loading: false
        });
      }
    } catch (error) {
      yield put({
        type: actions.FETCH_SUB_CHANNEL_PAYLOAD_BY_ID_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* updateSubChannelPayload() {
  yield takeEvery('UPDATE_SUB_CHANNEL_PAYLOAD', function* ({ payload, id }) {
    try {
      yield put({
        type: actions.UPDATING_SUB_CHANNEL_PAYLOAD,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield updateSubChannelPayloadAPI(payload, id, roleHeaderAuth);

      const result = apiResult.data;
      if (result.success) {
        yield put({
          type: actions.UPDATE_SUB_CHANNEL_PAYLOAD_SUCCESS,
          loading: false,
          message: result.message,
          result: result ? result.data : null
        });
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.UPDATE_SUB_CHANNEL_PAYLOAD_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.UPDATE_SUB_CHANNEL_PAYLOAD_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.UPDATE_SUB_CHANNEL_PAYLOAD_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* addProcessorPayload() {
  yield takeEvery('ADD_PROCESSOR_PAYLOAD', function* ({ payload, id }) {
    try {
      yield put({
        type: actions.ADDING_PROCESSOR_PAYLOAD,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield addProcessorPayloadAPI(payload, id, roleHeaderAuth);

      const result = apiResult.data;
      if (result.success) {
        yield put({
          type: actions.ADD_PROCESSOR_PAYLOAD_SUCCESS,
          loading: false,
          message: result.message,
          result: result ? result.data : null
        });
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.ADD_PROCESSOR_PAYLOAD_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.ADD_PROCESSOR_PAYLOAD_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.ADD_PROCESSOR_PAYLOAD_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* updateProcessorPayload() {
  yield takeEvery('UPDATE_PROCESSOR_PAYLOAD', function* ({ payload, id }) {
    try {
      yield put({
        type: actions.UPDATING_PROCESSOR_PAYLOAD,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield updateProcessorPayloadAPI(payload, id, roleHeaderAuth);

      const result = apiResult.data;
      if (result.success) {
        yield put({
          type: actions.UPDATE_PROCESSOR_PAYLOAD_SUCCESS,
          loading: false,
          message: result.message,
          result: result ? result.data : null
        });
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.UPDATE_PROCESSOR_PAYLOAD_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.UPDATE_PROCESSOR_PAYLOAD_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.UPDATE_PROCESSOR_PAYLOAD_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* addMerchantSpecificPayload() {
  yield takeEvery('ADD_MERCHANT_SPECIFIC_PAYLOAD', function* ({ payload, id }) {
    try {
      yield put({
        type: actions.ADDING_MERCHANT_SPECIFIC_PAYLOAD,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield addMerchantSpecificPayloadAPI(payload, id, roleHeaderAuth);

      const result = apiResult.data;
      if (result.success) {
        yield put({
          type: actions.ADD_MERCHANT_SPECIFIC_PAYLOAD_SUCCESS,
          loading: false,
          message: result.message,
          result: result ? result.data : null
        });
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.ADD_MERCHANT_SPECIFIC_PAYLOAD_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.ADD_MERCHANT_SPECIFIC_PAYLOAD_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.ADD_MERCHANT_SPECIFIC_PAYLOAD_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* fetchMerchantSpecificPayloadByID() {
  yield takeEvery('FETCH_MERCHANT_SPECIFIC_PAYLOAD_BY_ID', function* ({ payload }) {
    try {
      yield put({
        type: actions.FETCHING_MERCHANT_SPECIFIC_PAYLOAD_BY_ID,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield fetchMerchantSpecificPayloadByIdAPI(payload, roleHeaderAuth);

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.FETCH_MERCHANT_SPECIFIC_PAYLOAD_BY_ID_SUCCESS,
          loading: false,
          message: result.message,
          result: result ? result.data : null
        });
      } else {
        yield put({
          type: actions.FETCH_MERCHANT_SPECIFIC_PAYLOAD_BY_ID_FAILED,
          message: result.message,
          loading: false
        });
      }
    } catch (error) {
      yield put({
        type: actions.FETCH_MERCHANT_SPECIFIC_PAYLOAD_BY_ID_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* updateMerchantSpecificPayload() {
  yield takeEvery('UPDATE_MERCHANT_SPECIFIC_PAYLOAD', function* ({ payload, id }) {
    try {
      yield put({
        type: actions.UPDATING_MERCHANT_SPECIFIC_PAYLOAD,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield updateMerchantSpecificPayloadAPI(payload, id, roleHeaderAuth);

      const result = apiResult.data;
      if (result.success) {
        yield put({
          type: actions.UPDATE_MERCHANT_SPECIFIC_PAYLOAD_SUCCESS,
          loading: false,
          message: result.message,
          result: result ? result.data : null
        });
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.UPDATE_MERCHANT_SPECIFIC_PAYLOAD_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.UPDATE_MERCHANT_SPECIFIC_PAYLOAD_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.UPDATE_MERCHANT_SPECIFIC_PAYLOAD_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* fetchMerchantSpecificPayloads() {
  yield takeEvery('FETCH_MERCHANT_SPECIFIC_PAYLOADS', function* () {
    try {
      yield put({
        type: actions.FETCHING_MERCHANT_SPECIFIC_PAYLOADS,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield fetchMerchantSpecificPayloadsAPI(roleHeaderAuth);

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.FETCH_MERCHANT_SPECIFIC_PAYLOADS_SUCCESS,
          loading: false,
          result: result ? result?.data : null
        });
      } else {
        yield put({
          type: actions.FETCH_MERCHANT_SPECIFIC_PAYLOADS_FAILED,
          loading: false
        });
      }
    } catch (error) {
      yield put({
        type: actions.FETCH_MERCHANT_SPECIFIC_PAYLOADS_FAILED,
        loading: false
      });
    }
  });
}

export function* fetchPaymentChannelConfigurations() {
  yield takeEvery('FETCH_PAYMENT_CHANNEL_CONFIGURATIONS', function* () {
    try {
      yield put({
        type: actions.FETCHING_PAYMENT_CHANNEL_CONFIGURATIONS,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield fetchPaymentChannelConfigurationsAPI(roleHeaderAuth);

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.FETCH_PAYMENT_CHANNEL_CONFIGURATIONS_SUCCESS,
          loading: false,
          result: result ? result?.data : null
        });
      } else {
        yield put({
          type: actions.FETCH_PAYMENT_CHANNEL_CONFIGURATIONS_FAILED,
          loading: false
        });
      }
    } catch (error) {
      yield put({
        type: actions.FETCH_PAYMENT_CHANNEL_CONFIGURATIONS_FAILED,
        loading: false
      });
    }
  });
}

export function* addIntegrationManagement() {
  yield takeEvery(actions.ADD_INTEGRATION_MANAGEMENT, function* ({ payload }) {
    try {
      yield put({
        type: actions.ADDING_INTEGRATION_MANAGEMENT,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield addIntegrationManagementAPI(payload, roleHeaderAuth);

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.ADD_INTEGRATION_MANAGEMENT_SUCCESS,
          loading: false,
          message: result.message
        });
        yield put({
          type: actions.FETCH_INTEGRATION_MANAGEMENT,
          payload: {},
          pagination: { page: 0, limit: 10 }
        });
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.ADD_INTEGRATION_MANAGEMENT_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.ADD_INTEGRATION_MANAGEMENT_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.ADD_INTEGRATION_MANAGEMENT_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* fetchIntegrationManagement() {
  yield takeEvery(actions.FETCH_INTEGRATION_MANAGEMENT, function* ({ payload }) {
    try {
      yield put({
        type: actions.FETCHING_INTEGRATION_MANAGEMENT,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield fetchIntegrationManagementAPI(
        payload,
        roleHeaderAuth
      );

      const result = apiResult.data;

      const integrationManagement = result?.data;

      if (result.success) {
        yield put({
          type: actions.FETCH_INTEGRATION_MANAGEMENT_SUCCESS,
          loading: false,
          result: result && integrationManagement ? integrationManagement : [],
          pagination: result.pagination ? result.pagination : null,
          filter: payload
        });
      } else {
        yield put({
          type: actions.FETCH_INTEGRATION_MANAGEMENT_FAILED,
          loading: false
        });
      }
    } catch (error) {
      yield put({
        type: actions.FETCH_INTEGRATION_MANAGEMENT_FAILED,
        loading: false
      });
    }
  });
}

export function* fetchIntegrationManagementByID() {
  yield takeEvery(actions.FETCH_INTEGRATION_MANAGEMENT_BY_ID, function* ({ payload }) {
    try {
      yield put({
        type: actions.FETCHING_INTEGRATION_MANAGEMENT_BY_ID,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield fetchIntegrationManagementByIdAPI(payload, roleHeaderAuth);

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.FETCH_INTEGRATION_MANAGEMENT_BY_ID_SUCCESS,
          loading: false,
          message: result.message,
          result: result ? result.data : null
        });
      } else {
        yield put({
          type: actions.FETCH_INTEGRATION_MANAGEMENT_BY_ID_FAILED,
          message: result.message,
          loading: false
        });
      }
    } catch (error) {
      yield put({
        type: actions.FETCH_INTEGRATION_MANAGEMENT_BY_ID_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* generateNewAPIKey() {
  yield takeEvery(actions.GENERATE_NEW_API_KEY_DATA, function* ({ payload, id }) {
    try {
      yield put({
        type: actions.GENERATING_NEW_API_KEY_DATA,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield generateNewAPIKeyAPI(payload, id, roleHeaderAuth);

      const result = apiResult.data;
      if (result.success) {
        yield put({
          type: actions.GENERATE_NEW_API_KEY_DATA_SUCCESS,
          loading: false,
          message: result.message,
          result: result ? result.data : null
        });
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.GENERATE_NEW_API_KEY_DATA_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.GENERATE_NEW_API_KEY_DATA_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.GENERATE_NEW_API_KEY_DATA_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* fetchReconAuditLogs() {
  yield takeEvery(
    actions.FETCH_RECON_AUDIT_LOGS,
    function* ({ payload, pagination }) {
      try {
        yield put({
          type: actions.FETCHING_RECON_AUDIT_LOGS,
          loading: true
        });
        const roleHeaderAuth = yield getRoleHeader();
        const apiResult = yield fetchReconAuditLogsAPI(payload, pagination, roleHeaderAuth);

        const result = apiResult.data;

        if (result.success) {
          yield put({
            type: actions.FETCH_RECON_AUDIT_LOGS_SUCCESS,
            loading: false,
            result: result ? result.data : null,
            pagination: result ? result.pagination : null,
            filter: payload
          });
        } else {
          yield put({
            type: actions.FETCH_RECON_AUDIT_LOGS_FAILED,
            loading: false
          });
        }
      } catch (error) {
        yield put({
          type: actions.FETCH_RECON_AUDIT_LOGS_FAILED,
          loading: false
        });
      }
    }
  );
}

export function* loadMoreReconAuditLogs() {
  yield takeEvery(actions.LOAD_MORE_RECON_AUDIT_LOGS, function* ({ payload, pagination }) {
    try {
      yield put({
        type: actions.LOADING_MORE_RECON_AUDIT_LOGS,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield fetchReconAuditLogsAPI(payload, pagination, roleHeaderAuth);

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.LOAD_MORE_RECON_AUDIT_LOGS_SUCCESS,
          loading: false,
          result: result ? result.data : null,
          pagination: result ? result.pagination : null,
          filter: payload
        });
      } else {
        yield put({
          type: actions.LOAD_MORE_RECON_AUDIT_LOGS_FAILED,
          loading: false
        });
      }
    } catch (error) {
      yield put({
        type: actions.LOAD_MORE_RECON_AUDIT_LOGS_FAILED,
        loading: false
      });
    }
  });
}


function fetchAllSystemSettingsAPI(roleAuth) {
  return get(`get/all/system-settings`, null, null, null, null, roleAuth);
}
function editSystemSettingsAPI(data, roleAuth) {
  return PUT(`edit/system-settings`, data, null, roleAuth);
}
function addSystemSettingsAPI(data, roleAuth) {
  return post(`add/system-settings`, data, null, null, roleAuth);
}
function fetchAllRoleAPI(roleAuth) {
  return get(`get-all/role`, null, null, null, null, roleAuth);
}
function fetchAllServiceDataAPI(roleAuth) {
  return get(`get/utility/otp-services`, null, null, null, null, roleAuth);
}
function fetchAllOTPServiceTemplateDataAPI(id, roleAuth) {
  return get(`get/utility/otp-services-template/${id}`, null, null, null, null, roleAuth);
}
function fetchAllOTPIntegratorsAPI(roleAuth) {
  return get(`get/utility/otp-integrators`, null, null, null, null, roleAuth);
}
function fetchAllOTPLogsAPI(payload, roleAuth) {
  return post(`get/utility/otp-logs`, payload, null, null, roleAuth);
}
function fetchAllOTPLogsActionCountAPI(data, roleAuth) {
  return post(`get/utility/otp-logs/action-count`, data, null, null, roleAuth);
}
function fetchAllCosmosLogsAPI( payload, roleAuth) {
  return post(`get-all/cosmos-logs`, payload, null, null, null, roleAuth);
}
function fetchPChannelListDataAPI(data, roleAuth) {
  return post(`get/all/payment-channel`, data, null, null, roleAuth);
}
function fetchAllModuleAPI(roleAuth) {
  return get(`get-all/modules`, null, null, null, null, roleAuth);
}
function fetchAllAddressAPI(roleAuth) {
  return get(`get-all/address`, null, null, null, null, roleAuth);
}
function fetchAllIndustryAPI(roleAuth) {
  return get(`get-all/industry`, null, null, null, null, roleAuth);
}
function fetchRoleByIDAPI(id, roleAuth) {
  return get(`get-by-id/role/${id}`, null, null, null, null, roleAuth);
}
function fetchUserListByRoleIDAPI(id, roleAuth) {
  return get(`get-by-role/user/${id}`, null, null, null, null, roleAuth);
}
function fetchUsersAPI(data, roleAuth) {
  return post(`fetch/users`, data, null, null, roleAuth);
}

function addModuleDataAPI(data, roleAuth) {
  return post(`add/module`, data, null, null, roleAuth);
}
function addRoleDataAPI(data, roleAuth) {
  return post(`add/role`, data, null, null, roleAuth);
}
function addLookupsDataAPI(data, roleAuth) {
  return post(`add/lookups`, data, null, null, roleAuth);
}
function editRoleDataAPI(data, id, roleAuth) {
  return PUT(`edit/role/${id}`, data, null, roleAuth);
}
function editExternalRecipientAPI(data, id, roleAuth) {
  return PUT(`edit/external-recipient/${id}`, data, null, roleAuth);
}

function fetchAllUserDeptDataAPI(roleAuth) {
  return get(`get-all-dept/user`, null, null, null, null, roleAuth);
}
function addUserDataAPI(data, roleAuth) {
  return post(`add/user`, data, null, null, roleAuth);
}
function fetchAllUserAPI(payload, roleAuth) {
  return post(
    `get-all/user`,
    payload,//data,
    null,//pagination ? pagination : { page: 0, limit: 10 },
    null,
    roleAuth
  );
}
function fetchAllLookupsAPI(roleAuth) {
  return get(`get-all/lookups`, null, null, null, null, roleAuth);
}
function fetchLookupsDataRevampedAPI(roleAuth) {
  return get(`get-all/lookups/revamped`, null, null, null, null, roleAuth);
}
function fetchPMethodListDataAPI(roleAuth) {
  return get(`get/all/payment-method`, null, null, null, null, roleAuth);
}
function fetchAllLookupValidationAPI(roleAuth) {
  return get(`get-all/lead-status/change-requirement`, null, null, null, null, roleAuth);
}
function fetchPChannelDataAPI(roleAuth) {
  return get(`get/all/payment`, null, null, null, null, roleAuth);
}
function fetchNotificationDataAPI(roleAuth) {
  return get(`get/notification`, null, null, null, null, roleAuth);
}
function editLookupsDataAPI(data, id, roleAuth) {
  return PUT(`edit/lookups/${id}`, data, null, roleAuth);
}
function editSystemStatusAPI(data, id, roleAuth) {
  return PUT(`change-status/system/${id}`, data, null, roleAuth);
}
function editLookupGroupDataAPI(data, id, roleAuth) {
  return PUT(`edit-by-group/lookups/${id}`, data, null, roleAuth);
}
function addIndustryDataAPI(data, roleAuth) {
  return post(`add/industry`, data, null, null, roleAuth);
}
function editIndustryDataAPI(data, id, roleAuth) {
  return PUT(`edit/industry/${id}`, data, null, roleAuth);
}
function addPaymentChannelAPI(data, roleAuth) {
  return post(`add/payment-channel`, data, null, null, roleAuth);
}
function addAddressDataAPI(data, roleAuth) {
  return post(`add-address/address`, data, null, null, roleAuth);
}

function addOtpAddressAPI(data, roleAuth) {
  return post(`add/utility/otp-services`, data, null, null, roleAuth);
}
function testGenerateOTPAPI(data, header) {
  return postTest(`test/generate/otp-service`, data, null, null, null, header);
}

function addOTPTemplateAPI(data, roleAuth) {
  return post(`add/utility/otp-services-template`, data, null, null, roleAuth);
}
function addProvinceDataAPI(data, roleAuth) {
  return post(`add-province/address`, data, null, null, roleAuth);
}
function reorderLookupDataAPI(data, roleAuth) {
  return PUT(`reorder/lookups`, data, null, null, roleAuth);
}
function reorderPageDataAPI(data, roleAuth) {
  return PUT(`reorder/system-page`, data, null, null, roleAuth);
}
function reorderModuleDataAPI(data, roleAuth) {
  return PUT(`reorder/system-module`, data, null, null, roleAuth);
}
function defineKeyCitiesAPI(data, roleAuth) {
  return PUT(`edit/key-city/address`, data, null, roleAuth);
}
function deleteLookupDataAPI(id, roleAuth) {
  return DELETE(`delete/lookups/${id}`, null, null, roleAuth);
}
function deleteLookupValidationDataAPI(id, roleAuth) {
  return DELETE(`delete/lead-status/change/requirement/${id}`, null, null, roleAuth);
}
function editAddressDataAPI(data, id, roleAuth) {
  return PUT(`edit/address/${id}`, data, null, roleAuth);
}
function editOTPSettingsDataAPI(data, id, roleAuth) {
  return PUT(`edit/utility/otp-services/${id}`, data, null, roleAuth);
}
function editOTPSettingsTemplateDataAPI(data, id, roleAuth) {
  return PUT(`edit/utility/otp-services-template/${id}`, data, null, roleAuth);
}
function generateNewKeyAPI(data, id, roleAuth) {
  return PUT(`generate-key/utility/otp-services/${id}`, data, null, roleAuth);
}
function changeStatusAddressDataAPI(data, id, roleAuth) {
  return PUT(`edit/address/${id}`, data, null, roleAuth);
}
function changeIndustryStatusDataAPI(data, id, roleAuth) {
  return PUT(`edit/industry/${id}`, data, null, roleAuth);
}
function deleteRoleDataAPI(id, roleAuth) {
  return DELETE(`delete/role/${id}`, null, null, roleAuth);
}
function deleteUserDataAPI(id, roleAuth) {
  return DELETE(`delete/user/${id}`, null, null, roleAuth);
}
function editUserDataAPI(data, id, roleAuth) {
  return PUT(`edit/user/${id}`, data, null, roleAuth);
}
function resetUserPasswordAPI(data, id, roleAuth) {
  return PUT(`reset-password/user/${id}`, data, null, roleAuth);
}
function unlockUserAPI(data, id, roleAuth) {
  return PUT(`unlock/user/${id}`, data, null, roleAuth);
}
function changeStatusUserDataAPI(data, id, roleAuth) {
  return PUT(`edit/user/${id}`, data, null, roleAuth);
}
function addNotificationDataAPI(data, roleAuth) {
  return post(`setup/notification-settings`, data, null, null, roleAuth);
}
function updateAppNotificationAPI(data, id, roleAuth) {
  return PUT(`edit-notification/user`, data, null, roleAuth);
}
function fetchAllExternalRecipientsAPI(roleAuth) {
  return get(`get-all/external-settings`, null, null, null, null, roleAuth);
}
function setLookupValidationDataAPI(data, id, roleAuth) {
  return post(`add/lead-status/change/requirement/${id}`, data, null, roleAuth);
}
function editLookupValidationDataAPI(data, id, roleAuth) {
  return PUT(`edit/lead-status/change/requirement/${id}`, data, null, roleAuth);
}
function fetchAllTemplateDataAPI(data, roleAuth) {
  return post(`get-all/template-data`, data, null, null, roleAuth);
}
function fetchAllBankTemplateDataAPI(data, roleAuth) {
  return post(`get-all/bank-template-data`, data, null, null, roleAuth);
}
function addTemplateDataAPI(data, roleAuth) {
  return post(`add/template-data`, data, null, null, roleAuth);
}
function fetchUserActivityAPI(payload, roleAuth) {
  return post(`get-all/cosmos-logs`, payload, null, null, null, roleAuth);
}
function fetchInvitedUserDataAPI(id) {
  return get(`fetch/invited-user-data/${id}`, null, null, null, null, null);
}
function logAccessInviteAPI(id) {
  return PUT(`log/invited-user-data/${id}`, null, null, null);
}
function fetchAllInvitedUsersDataAPI(data, roleAuth) {
  return post(`get-all/invited-users`, data, null, null, roleAuth);
}
function inviteUserDataAPI(data, roleAuth) {
  return post(`invite/user`, data, null, null, roleAuth);
}
function resendInviteUserDataAPI(data, roleAuth) {
  return post(`resend-invite/user`, data, null, null, roleAuth);
}
function signUpUserDataAPI(data) {
  return post(`sign-up/user`, data, null, null, null);
}
function addBankTemplateDataAPI(data, roleAuth) {
  return post(`add/bank-template-data`, data, null, null, roleAuth);
}
function editTemplateDataAPI(data, id, roleAuth) {
  return PUT(`edit/template-data/${id}`, data, null, roleAuth);
}
function editPaynamicsBankTemplateAPI(data, id, roleAuth) {
  return PUT(`edit/bank-template-data/${id}`, data, null, roleAuth);
}
function fetchAllUploadedFilesAPI(payload, roleAuth) {
  return post(`get-all/upload-file`, payload, null, null, roleAuth);
}
function uploadFileDataAPI(data, roleAuth) {
  return post(`upload/upload-file`, data, null, null, roleAuth);
}
function uploadBankTrxDataAPI(data, roleAuth) {
  return post(`upload/bank-file`, data, null, null, roleAuth);
}
function uploadMultipleFileDataAPI(data, roleAuth) {
  return post(`upload/upload-multiple-file`, data, null, null, roleAuth);
}
function uploadLeadsFileDataAPI(data, roleAuth) {
  return post(`upload/upload-leads-file`, data, null, null, roleAuth);
}
function reuploadLeadsFileDataAPI(data, roleAuth) {
  return post(`upload/reupload-leads-file`, data, null, null, roleAuth);
}
function reuploadFileDataAPI(id, data, roleAuth) {
  return post(`re-upload/upload-file/${id}`, data, null, null, roleAuth);
}
function getPreSignedURLAPI(filename, roleAuth) {
  return get(`get/utility/presigned-s3-url/${filename}`, null, null, null, null, roleAuth);
}
function getPresignedURLWithKeyAPI(filename, roleAuth) {
  return get(`get/utility/presigned-s3-url-with-key/${filename}`, null, null, null, null, roleAuth);
}
function getMultiplePreSignedURLAPI(data, roleAuth) {
  return post(`get/utility/multiple-presigned-s3-url`, data, null, null, roleAuth);
}
function fetchPaynamicsBanksDataAPI(roleAuth) {
  return get(`get/all/paynamics-bank`, null, null, null, roleAuth);
}
function addPaynamicsBankAPI(data, roleAuth) {
  return post(`add/paynamics-bank`, data, null, null, roleAuth);
}
function editPaynamicsBankAPI(id, data, roleAuth) {
  return PUT(`edit/paynamics-bank/${id}`, data, null, null, roleAuth);
}
function fetchLogsByItemIdAPI(id, payload, roleAuth) {
  return post(`log/by-item-id/${id}`, payload, null, null, roleAuth);
}
function addPageActionAPI(data, roleAuth) {
  return post(`add/page-action`, data, null, null, roleAuth);
}
function editPageActionAPI(data, id, roleAuth) {
  return PUT(`edit/page-action/${id}`, data, null, null, roleAuth);
}
function editPaymentChannelDataAPI(data, id, roleAuth) {
  return PUT(`edit/paymentChannel/${id}`, data, null, null, roleAuth);
}
function editNotifSettingAPI(data, id, roleAuth) {
  return PUT(`edit/notification-settings/${id}`, data, null, roleAuth);
}
function addPaymentChannelPayloadAPI(data, id, roleAuth) {
  return post(`add/channel-payloads/${id}`, data, null, null, roleAuth);
}
function fetchPaymentChannelPayloadByIdAPI(data, roleAuth) {
  return post(`get-by-id/channel-payloads`, data, null, null, roleAuth);
}
function updatePaymentChannelPayloadAPI(data, id, roleAuth) {
  return PUT(`edit/channel-payloads/${id}`, data, null, roleAuth);
}
function fetchInstallmentModePayloadByIdAPI(data, roleAuth) {
  return post(`get-by-id/installment-mode-payloads`, data, null, null, roleAuth);
}
function addInstallmentModePayloadAPI(data, id, roleAuth) {
  return post(`add/installment-mode-payloads/${id}`, data, null, null, roleAuth);
}
function updateInstallmentModePayloadAPI(data, id, roleAuth) {
  return PUT(`edit/installment-mode-payloads/${id}`, data, null, roleAuth);
}
function addInstallmentTenorPayloadAPI(data, id, roleAuth) {
  return post(`add/installment-tenor-payloads/${id}`, data, null, null, roleAuth);
}
function updateInstallmentTenorPayloadAPI(data, id, roleAuth) {
  return PUT(`edit/installment-tenor-payloads/${id}`, data, null, roleAuth);
}
function fetchSubChannelPayloadByIdAPI(data, roleAuth) {
  return post(`get-by-id/sub-channel-payloads`, data, null, null, roleAuth);
}
function addSubChannelPayloadAPI(data, id, roleAuth) {
  return post(`add/sub-channel-payloads/${id}`, data, null, null, roleAuth);
}
function updateSubChannelPayloadAPI(data, id, roleAuth) {
  return PUT(`edit/sub-channel-payloads/${id}`, data, null, roleAuth);
}
function addProcessorPayloadAPI(data, id, roleAuth) {
  return post(`add/processor-payloads/${id}`, data, null, null, roleAuth);
}
function updateProcessorPayloadAPI(data, id, roleAuth) {
  return PUT(`edit/processor-payloads/${id}`, data, null, roleAuth);
}
function addMerchantSpecificPayloadAPI(data, id, roleAuth) {
  return post(`add/merchant-specific-payloads/${id}`, data, null, null, roleAuth);
}
function fetchMerchantSpecificPayloadByIdAPI(data, roleAuth) {
  return post(`get-by-id/merchant-specific-payloads`, data, null, null, roleAuth);
}
function updateMerchantSpecificPayloadAPI(data, id, roleAuth) {
  return PUT(`edit/merchant-specific-payloads/${id}`, data, null, roleAuth);
}
function fetchMerchantSpecificPayloadsAPI(roleAuth) {
  return get(`merchant-specific-payloads`, null, null, null, null, roleAuth);
}
function fetchPaymentChannelConfigurationsAPI(roleAuth) {
  return get(`get/configuration/payment-channel`, null, null, null, null, roleAuth);
}

function addIntegrationManagementAPI(data, roleAuth) {
  return post(`add/integration-management`, data, null, null, roleAuth);
}
function fetchIntegrationManagementAPI(payload, roleAuth) {
  return post(`get-all/integration-management`, payload, null, null, null, roleAuth);
}
function fetchIntegrationManagementByIdAPI(data, roleAuth) {
  return post(`get-by-id/integration-management`, data, null, null, roleAuth);
}
function generateNewAPIKeyAPI(data, id, roleAuth) {
  return PUT(`generate-key/integration-management/${id}`, data, null, roleAuth);
}

function deleteBankTrxDataAPI(id, roleAuth) {
  return DELETE(`delete/upload-data/${id}`, null, null, roleAuth);
}

function fetchReconAuditLogsAPI(data, pagination, roleAuth) {
  return post(`recon/logs-by-pchannel`, data, pagination, null, roleAuth);
}

async function uploadFileToS3(url, payload) {
  return await fetch(url, {
    method: 'PUT',
    headers: {
      'Content-Type': payload.file.type
    },
    body: payload.file
  });
}

function uploadFileToS3WithProgress(url, payload, onProgress) {
  return new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest();

    // Set up the request
    xhr.open('PUT', url, true);
    xhr.setRequestHeader('Content-Type', payload.file.type);

    xhr.upload.onprogress = function (event) {
      console.log(event);
      if (event.lengthComputable) {
        const percentComplete = (event.loaded / event.total) * 100;
        onProgress(percentComplete);
      }
    };

    xhr.onload = function () {
      if (xhr.status >= 200 && xhr.status < 300) {
        resolve({
          success: true,
          message: 'File uploaded successfully'
        });
      } else {
        reject({
          success: false,
          message: `Upload failed with status ${xhr.status}`
        });
      }
    };

    xhr.onerror = function () {
      reject({
        success: false,
        message: 'An error occurred during the upload'
      });
    };

    xhr.send(payload.file);
  });
}

async function reuploadFileToS3(url, payload) {
  return await fetch(url, {
    method: 'PUT',
    headers: {
      'Content-Type': payload.file.type
    },
    body: payload.file
  });
}

function* getRoleHeader() {
  const state = yield select();
  const identity = state.Auth.identity;
  const currentPage = state.App.currentPage;
  const currentAction = state.App.currentAction;
  if (currentAction) {
    return `${identity.role_id}:${currentPage.id}:${currentAction.id}`;
  } else {
    return `${identity.role_id}:${currentPage.id}`;
  }
}
export default function* rootSaga() {
  yield all([
    fork(fetchAllRoles),
    fork(fetchAllIndustries),
    fork(fetchRoleByID),
    fork(fetchUsers),
    fork(addRoleData),
    fork(editRoleData),
    fork(editSystemStatus),
    fork(addUserData),
    fork(fetchAllUsers),
    fork(fetchAllLookups),
    fork(fetchAllAddresses),
    fork(addLookupsData),
    fork(editLookupsData),
    fork(editLookupGroupData),
    fork(addIndustryData),
    fork(editIndustryData),
    fork(addAddressData),
    fork(addProvinceData),
    fork(defineKeyCities),
    fork(deleteLookupData),
    fork(editAddressData),
    fork(changeAddressStatusData),
    fork(changeIndustryStatusData),
    fork(deleteRoleData),
    fork(deleteUserData),
    fork(editUserData),
    fork(resetUserPassword),
    fork(unlockUser),
    fork(changeUserStatus),
    fork(fetchAllModules),
    fork(addModuleData),
    fork(fetchPaymentChannelsData),
    fork(fetchNotificationData),
    fork(addNotificationData),
    fork(updateAppNotificationData),
    fork(getUserListByRole),
    fork(reorderLookupData),
    fork(reorderPageData),
    fork(fetchAllExternalRecipients),
    fork(reorderModuleData),
    fork(editExternalRecipientData),
    fork(fetchLookupValidation),
    fork(setLookupValidationData),
    fork(editLookupValidationData),
    fork(deleteLookupValidationData),
    fork(fetchPaymentChannelListData),
    fork(fetchPaymentMethodListData),
    fork(fetchAllTemplateData),
    fork(addTemplateData),
    fork(editTemplateData),
    fork(fetchAllUploadedFiles),
    fork(uploadFileData),
    fork(getPreSignedURL),
    fork(reuploadFileData),
    fork(fetchAllCosmosLogs),
    fork(getMultiplePresignedURL),
    fork(getPresignedURLWithKey),
    fork(uploadBankTrxData),
    fork(uploadMultipleFileData),
    fork(uploadLeadsFileData),
    fork(reuploadLeadsFileData),
    fork(fetchAllBankTemplateData),
    fork(fetchAllSystemSettings),
    fork(editSystemSettings),
    fork(addSystemSettings),
    fork(addBankTemplateData),
    fork(editPaynamicsBankTemplateDetails),
    fork(fetchAllPaynamicsBanks),
    fork(addPaynamicsBank),
    fork(editPaynamicsBank),
    fork(addNewPageAction),
    fork(fetchUserActivity),
    fork(fetchAllOTPServices),
    fork(fetchAllOTPServicesTemplate),
    fork(generateNewOTPKey),
    fork(addOTPServiceData),
    fork(addOTPServiceTemplateData),
    fork(testGenerateOTP),
    fork(editOtpConfig),
    fork(editOTPConfigTemplate),
    fork(fetchLogsByItemId),
    fork(inviteUserData),
    fork(resendInviteUserData),
    fork(fetchInvitedUserDetails),
    fork(logAccessInvite),
    fork(signUpUserData),
    fork(editPaymentChannel),
    fork(fetchAllUserDeptData),
    fork(addPaymentChannelData),
    fork(fetchAllInvitedUsersData),
    fork(fetchAllOTPIntegrators),
    fork(fetchAllOTPLogs),
    fork(fetchAllOTPLogsActionCount),
    fork(editPageAction),
    fork(editNotifSetting),
    fork(fetchLookupsDataRevamped),
    fork(addPaymentChannelPayload),
    fork(fetchPaymentChannelPayloadByID),
    fork(updatePaymentChannelPayload),
    fork(addMerchantSpecificPayload),
    fork(fetchMerchantSpecificPayloadByID),
    fork(updateMerchantSpecificPayload),
    fork(fetchMerchantSpecificPayloads),
    fork(addInstallmentModePayload),
    fork(fetchInstallmentModePayloadByID),
    fork(updateInstallmentModePayload),
    fork(addInstallmentTenorPayload),
    fork(updateInstallmentTenorPayload),
    fork(addSubChannelPayload),
    fork(fetchSubChannelPayloadByID),
    fork(updateSubChannelPayload),
    fork(addProcessorPayload),
    fork(updateProcessorPayload),
    fork(fetchPaymentChannelConfigurations),
    fork(addIntegrationManagement),
    fork(fetchIntegrationManagement),
    fork(fetchIntegrationManagementByID),
    fork(generateNewAPIKey),
    fork(reuploadBankTrxData),
    fork(fetchReconAuditLogs),
    fork(loadMoreReconAuditLogs)
  ]);
}
